export const initialCards: any[] =[
  {
    "id": "card1",
    "icon": "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/Group 61722@2x-odNcjqtKioND.png",
    "name": "Outlet Master",
    "formId": "1d559bf2-e72d-4427-ab03-6d36e07c9158",
    "getAPI": "outletDetails",
    "actions": [
      "ChangeStatus"
    ],
    "postAPI": "streamlet",
    "configAPI": "/outletDetails/id",
    "toggleAPI": "outletDetails/toggle",
    "reportName": "master_report_outlet",
    "mandatory": true,
    "entityName": "OutletDetails",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "label": "Logs and Reports"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      },
      {
        "id": "masterDownload",
        "label": "Master Download"
      }
    ],
    "description": "This master contains data regarding all retail outlets.",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/ckcoeuat/images/OutletPOC4-LWiyIEnCLxxJ.xlsx",
    "transformer": [
      {
        "entityName": "OutletDetails",
        "operationType": "insert",
        "transformerId": "Kavincare_DMS_outetMaster_transformer"
      }
    ],
    "activeStatusKey": "active",
    "supportedParams": "?flattenOut=true&AccountInfo=true&CreditStatus=true&Location=true&UserParent=true",
    "tableConfiguration": {
      "columns": [
        {
          "id": "outletAttr5",
          "label": "companycode",
          "mandatory": false,
          "columnName": "companycode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "companycode"
        },
        {
          "id": "outletAttr6",
          "label": "distroutletcode",
          "mandatory": false,
          "columnName": "distroutletcode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "distroutletcode"
        },
        {
          "id": "outletCode",
          "label": "outletcode",
          "mandatory": false,
          "columnName": "outletcode",
          "tableField": "outletCode",
          "showInTable": true,
          "postMappingField": "outletcode"
        },
        {
          "id": "outletName",
          "label": "outletname",
          "mandatory": false,
          "columnName": "outletname",
          "tableField": "outletName",
          "showInTable": true,
          "postMappingField": "outletname"
        },
        {
          "id": "contactno",
          "label": "contactno",
          "mandatory": false,
          "columnName": "contactno",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "contactno"
        },
        {
          "id": "beat",
          "label": "beat",
          "mandatory": false,
          "columnName": "beat",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "beat"
        },
        {
          "id": "beatName",
          "label": "beatName",
          "mandatory": false,
          "columnName": "beatName",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "beatName"
        },
        {
          "id": "activeStatus",
          "label": "active",
          "mandatory": false,
          "columnName": "active",
          "tableField": "activeStatus",
          "showInTable": true,
          "postMappingField": "active"
        },
        {
          "id": "doo",
          "label": "dateofopening",
          "mandatory": false,
          "columnName": "dateofopening",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "dateofopening"
        },
        {
          "id": "dateofclosing",
          "label": "dateofclosing",
          "mandatory": false,
          "columnName": "dateofclosing",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "dateofclosing"
        },
        {
          "id": "email",
          "label": "Outlet email ID",
          "mandatory": false,
          "columnName": "Outlet email ID",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet email ID"
        },
        {
          "id": "extendedAttributes.OutletChannelCode",
          "label": "Outlet's Channel Code",
          "mandatory": false,
          "columnName": "Outlet's Channel Code",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet's Channel Code"
        },
        {
          "id": "channel",
          "label": "channel",
          "mandatory": false,
          "columnName": "channel",
          "tableField": "channel",
          "showInTable": true,
          "postMappingField": "channel"
        },
        {
          "id": "subChannel",
          "label": "subchannel",
          "mandatory": false,
          "columnName": "subchannel",
          "tableField": "subChannel",
          "showInTable": true,
          "postMappingField": "subchannel"
        },
        {
          "id": "outletCategory",
          "label": "outletcategory",
          "mandatory": false,
          "columnName": "outletcategory",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "outletcategory"
        },
        {
          "id": "outletClass",
          "label": "outletClass",
          "mandatory": false,
          "columnName": "outletClass",
          "tableField": "outletClass",
          "showInTable": true,
          "postMappingField": "outletClass"
        },
        {
          "id": "outletType",
          "label": "outlettype",
          "mandatory": false,
          "columnName": "outlettype",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "outlettype"
        },
        {
          "id": "outletDivision",
          "label": "outletdivision",
          "mandatory": false,
          "columnName": "outletdivision",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "outletdivision"
        },
        {
          "id": "distributionChannel",
          "label": "distributionchannel",
          "mandatory": false,
          "columnName": "distributionchannel",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "distributionchannel"
        },
        {
          "id": "marketId",
          "label": "marketid",
          "mandatory": false,
          "columnName": "marketid",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "marketid"
        },
        {
          "id": "marketName",
          "label": "marketname",
          "mandatory": false,
          "columnName": "marketname",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "marketname"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "VPO",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "VPO"
        },
        {
          "id": "account",
          "label": "account",
          "mandatory": false,
          "columnName": "account",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "account"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "segment",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "segment"
        },
        {
          "id": "address",
          "label": "address 1",
          "mandatory": false,
          "columnName": "address 1",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "address 1"
        },
        {
          "id": "address5",
          "label": "address 2",
          "mandatory": false,
          "columnName": "address 2",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "address 2"
        },
        {
          "id": "Location.city",
          "label": "city",
          "mandatory": false,
          "columnName": "city",
          "tableField": "city",
          "showInTable": true,
          "postMappingField": "city"
        },
        {
          "id": "Location.region",
          "label": "region",
          "mandatory": false,
          "columnName": "region",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "region"
        },
        {
          "id": "Location.zone",
          "label": "zone",
          "mandatory": false,
          "columnName": "zone",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "zone"
        },
        {
          "id": "Location.district",
          "label": "district",
          "mandatory": false,
          "columnName": "district",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "district"
        },
        {
          "id": "Location.territory",
          "label": "territory",
          "mandatory": false,
          "columnName": "territory",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "territory"
        },
        {
          "id": "Location.area",
          "label": "area",
          "mandatory": false,
          "columnName": "area",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "area"
        },
        {
          "id": "Location.town",
          "label": "town",
          "mandatory": false,
          "columnName": "town",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "town"
        },
        {
          "id": "Location.branch",
          "label": "branch",
          "mandatory": false,
          "columnName": "branch",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "branch"
        },
        {
          "id": "Location.pincode",
          "label": "pincode",
          "mandatory": false,
          "columnName": "pincode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "pincode"
        },
        {
          "id": "Location.state",
          "label": "state",
          "mandatory": false,
          "columnName": "state",
          "tableField": "Location.state",
          "showInTable": true,
          "postMappingField": "state"
        },
        {
          "id": "Location.country",
          "label": "country",
          "mandatory": false,
          "columnName": "country",
          "tableField": "Location.country",
          "showInTable": true,
          "postMappingField": "country"
        },
        {
          "id": "latitude",
          "label": "latitude",
          "mandatory": false,
          "columnName": "latitude",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "latitude"
        },
        {
          "id": "longitude",
          "label": "longitude",
          "mandatory": false,
          "columnName": "longitude",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "longitude"
        },
        {
          "id": "tinNo",
          "label": "tinno",
          "mandatory": false,
          "columnName": "tinno",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "tinno"
        },
        {
          "id": "gstno",
          "label": "gstno",
          "mandatory": false,
          "columnName": "gstno",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "gstno"
        },
        {
          "id": "fssaiNumber",
          "label": "Outlet FSSAI Number",
          "mandatory": false,
          "columnName": "Outlet FSSAI Number",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet FSSAI Number"
        },
        {
          "id": "AccountInfo.pan",
          "label": "Outlet PAN",
          "mandatory": false,
          "columnName": "Outlet PAN",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet PAN"
        },
        {
          "id": "paymentMode",
          "label": "Outlet Payment mode",
          "mandatory": false,
          "columnName": "Outlet Payment mode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet Payment mode"
        },
        {
          "id": "extendedAttributes.SalesMode",
          "label": "Sales Mode",
          "mandatory": false,
          "columnName": "Sales Mode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Sales Mode"
        },
        {
          "id": "CreditStatus.creditLimit",
          "label": "Outlet Credit Limit",
          "mandatory": false,
          "columnName": "Outlet Credit Limit",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet Credit Limit"
        },
        {
          "id": "CreditStatus.creditLimit - CreditStatus.creditAvailable",
          "label": "Outlet Outstanding Balance",
          "mandatory": false,
          "columnName": "Outlet Outstanding Balance",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet Outstanding Balance"
        },
        {
          "id": "tcsEligibility",
          "label": "TCS eligibility",
          "mandatory": false,
          "columnName": "TCS eligibility",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "TCS eligibility"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "Key Account(Y/N)",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Key Account(Y/N)"
        },
        {
          "id": "AccountInfo.bankName",
          "label": "Outlet Bank",
          "mandatory": false,
          "columnName": "Outlet Bank",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet Bank"
        },
        {
          "id": "AccountInfo.ifsc",
          "label": "Outlet IFSC Code",
          "mandatory": false,
          "columnName": "Outlet IFSC Code",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet IFSC Code"
        },
        {
          "id": "AccountInfo.accountNumber",
          "label": "Outlet Account Number",
          "mandatory": false,
          "columnName": "Outlet Account Number",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet Account Number"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "Outlet Cash Discount",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet Cash Discount"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "IsTaxable",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "IsTaxable"
        },
        {
          "id": "CreditStatus.totalDueDays",
          "label": "Credit days",
          "mandatory": false,
          "columnName": "Credit days",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Credit days"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "Outlet Discount (%)",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Outlet Discount (%)"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "Discount group",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Discount group"
        },
        {
          "id": "priceListId",
          "label": "priceListId",
          "mandatory": false,
          "columnName": "priceListId",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "priceListId"
        },
        {
          "id": "extendedAttributes.parent-0-1-id",
          "label": "parent-0-1-id",
          "mandatory": false,
          "columnName": "parent-0-1-id",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "parent-0-1-id"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "Loyalty balance",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Loyalty balance"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "Wallet balance",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Wallet balance"
        },
        {
          "id": "prodauthcode",
          "label": "prodauthcode",
          "mandatory": false,
          "columnName": "prodauthcode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "prodauthcode"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "BirthDt",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "BirthDt"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "AnnivDt",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "AnnivDt"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "Supply Chain",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Supply Chain"
        },
        {
          "id": "",
          "label": "",
          "mandatory": false,
          "columnName": "ContactPerson Name",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "ContactPerson Name"
        }
      ]
    },
    "searchEnabledColumns": [
      "outletCode",
      "outletName"
    ]
  },
  {
    "id": "card2",
    "icon": "https://d2nvw4ekms3xzy.cloudfront.net/hccbckinduat/images/user-EIfqZsLLHDfJ.png",
    "name": "User master",
    "formId": "a2fceea0-6160-4e90-841b-90ff954f9255",
    "getAPI": "users",
    "actions": [
      "ChangeStatus",
      "ResetPassword",
      "Edit"
    ],
    "postAPI": "streamlet",
    "configAPI": "/users/id",
    "reportName": "master_report_user",
    "toggleAPI": "/users/toggle",
    "mandatory": true,
    "entityName": "User",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "label": "Logs and Reports"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      },
      {
        "id": "masterDownload",
        "label": "Master Download"
      },
      {
        "id": "dataSupportDownload",
        "label": "Data Validation Support"
      }
    ],
    "description": "Contains detailed information about all salesrep within the system.",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/ckcoeuat/images/SalesmanMDM-WjBjjESHKvyi-gsoDMcDYZkEA.xlsx",
    "transformer": [
      {
        "entityName": "User",
        "operationType": "Insert",
        "transformerId": "dms_mdm_salesman_user_transformer"
      }
    ],
    "activeStatusKey": "Active",
    "supportedParams": "?flattenOut=true&Location=true&UserParent=true",
    "tableConfiguration": {
      "columns": [
        {
          "id": "loginId",
          "label": "loginid",
          "mandatory": false,
          "columnName": "loginid",
          "tableField": "loginId",
          "showInTable": true,
          "postMappingField": "loginid"
        },
        {
          "id": "name",
          "label": "name",
          "mandatory": false,
          "columnName": "name",
          "tableField": "name",
          "showInTable": true,
          "postMappingField": "name"
        },
        {
          "id": "designation.0.designation",
          "label": "designation",
          "mandatory": false,
          "columnName": "designation",
          "tableField": "designation.0.designation",
          "showInTable": true,
          "postMappingField": "designation"
        },
        {
          "id": "UserParent.parent",
          "label": "parentid-1",
          "mandatory": false,
          "columnName": "parentid-1",
          "tableField": "UserParent.parent",
          "showInTable": true,
          "postMappingField": "parentid-1"
        },
        {
          "id": "mobile",
          "label": "mobile",
          "mandatory": false,
          "columnName": "mobile",
          "tableField": "mobile",
          "showInTable": true,
          "postMappingField": "mobile"
        },
        {
          "id": "activeStatus",
          "label": "active",
          "mandatory": false,
          "columnName": "active",
          "tableField": "activeStatus",
          "showInTable": true,
          "postMappingField": "active"
        },
        {
          "id": "email",
          "label": "email",
          "mandatory": false,
          "columnName": "email",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "email"
        },
        {
          "id": "prodauthcode",
          "label": "prodauth",
          "mandatory": false,
          "columnName": "prodauth",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "prodauth"
        },
        {
          "id": "extendedAttributes.region",
          "label": "region",
          "mandatory": false,
          "columnName": "region",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "region"
        },
        {
          "id": "Location.country",
          "label": "country",
          "mandatory": false,
          "columnName": "country",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "country"
        },
        {
          "id": "doa",
          "label": "doj",
          "mandatory": false,
          "columnName": "doj",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "doj"
        },
        {
          "id": "dob",
          "label": "dob",
          "mandatory": false,
          "columnName": "dob",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "dob"
        },
        {
          "id": "contactType",
          "label": "salesmantype",
          "mandatory": false,
          "columnName": "salesmantype",
          "tableField": "contactType",
          "showInTable": true,
          "postMappingField": "salesmantype"
        },
        {
          "id": "salary",
          "label": "salary",
          "mandatory": false,
          "columnName": "salary",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "salary"
        },
        {
          "id": "dailyallowance",
          "label": "dailyallowance",
          "mandatory": false,
          "columnName": "dailyallowance",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "dailyallowance"
        },
        {
          "id": "replacementfor",
          "label": "replacementfor",
          "mandatory": false,
          "columnName": "replacementfor",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "replacementfor"
        },
        {
          "id": "extendedAttributes.thirdPartyEmployeeCode",
          "label": "ThirdPartyEmployeeCode",
          "mandatory": false,
          "columnName": "ThirdPartyEmployeeCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "ThirdPartyEmployeeCode"
        },
        {
          "id": "extendedAttributes.beatLockingType",
          "label": "beatLockingType",
          "mandatory": false,
          "columnName": "beatLockingType",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "beatLockingType"
        }
      ]
    },
    "searchEnabledColumns": [
      "loginId",
      "name",
      "mobile"
    ]
  },
  {
    "id": "card3",
    "icon": "https://d2nvw4ekms3xzy.cloudfront.net/hccbckinduat/images/product-ySWXErLjTUNI.png",
    "name": "Product Master",
    "formId": "b0a89b3a-1644-4e37-990c-eebd77747963",
    "getAPI": "products",
    "actions": [],
    "postAPI": "streamlet",
    "configAPI": "/productDetails/id",
    "reportName": "master_report_product",
    "mandatory": true,
    "entityName": "ProductDetails",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      },
      {
        "id": "logsAndReport",
        "label": "Logs and Reports"
      }
    ],
    "description": "This master holds all SKU-related data, including SKU descriptions, pricing & images.",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/ckcoeuat/images/Product_Master_Template-QQmjqIUKPUNK.xlsx",
    "transformer": [
      {
        "entityName": "ProductDetails",
        "operationType": "insert",
        "transformerId": "Cavincare_Product_Master_transformer"
      }
    ],
    "activeStatusKey": "",
    "supportedParams": "?flattenOut=true",
    "tableConfiguration": {
      "columns": [
        {
          "id": "productCode",
          "label": "ProductCode",
          "mandatory": false,
          "columnName": "ProductCode",
          "tableField": "productCode",
          "showInTable": true,
          "postMappingField": "ProductCode"
        },
        {
          "id": "skuPcWeightUom",
          "label": "ProductWeightType",
          "mandatory": false,
          "columnName": "ProductWeightType",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "ProductWeightType"
        },
        {
          "id": "activeStatus",
          "label": "IsActive",
          "mandatory": false,
          "columnName": "IsActive",
          "tableField": "activeStatus",
          "showInTable": true,
          "postMappingField": "IsActive"
        },
        {
          "id": "shelfLifeDays",
          "label": "ShelfLife",
          "mandatory": false,
          "columnName": "ShelfLife",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "ShelfLife"
        },
        {
          "id": "skuPieceWeight",
          "label": "ProductNetWeight",
          "mandatory": false,
          "columnName": "ProductNetWeight",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "ProductNetWeight"
        },
        {
          "id": "extendedAttributes.isDrugProduct",
          "label": "IsDrugProduct",
          "mandatory": false,
          "columnName": "IsDrugProduct",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "IsDrugProduct"
        },
        {
          "id": "skuDescription",
          "label": "ProductName",
          "mandatory": false,
          "columnName": "ProductName",
          "tableField": "skuDescription",
          "showInTable": true,
          "postMappingField": "ProductName"
        },
        {
          "id": "skuName",
          "label": "ProductShortName",
          "mandatory": false,
          "columnName": "ProductShortName",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "ProductShortName"
        },
        {
          "id": "itemType",
          "label": "ProductType",
          "mandatory": false,
          "columnName": "ProductType",
          "tableField": "itemType",
          "showInTable": true,
          "postMappingField": "ProductType"
        },
        {
          "id": "skuCode",
          "label": "CompanyProductCode",
          "mandatory": false,
          "columnName": "CompanyProductCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "CompanyProductCode"
        },
        {
          "id": "ProdHierLevelCode",
          "label": "ProdHierLevelCode",
          "mandatory": false,
          "columnName": "ProdHierLevelCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "ProdHierLevelCode"
        },
        {
          "id": "otherProduct",
          "label": "ProdHierValueCode",
          "mandatory": false,
          "columnName": "ProdHierValueCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "ProdHierValueCode"
        },
        {
          "id": "eanNumber",
          "label": "ProductEanCode",
          "mandatory": false,
          "columnName": "ProductEanCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "ProductEanCode"
        },
        {
          "id": "extendedAttributes.hsnname",
          "label": "HsnName",
          "mandatory": false,
          "columnName": "HsnName",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "HsnName"
        },
        {
          "id": "tariffCode",
          "label": "HsnCode",
          "mandatory": false,
          "columnName": "HsnCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "HsnCode"
        },
        {
          "id": "extendedAttributes.division",
          "label": "DivisionCode",
          "mandatory": false,
          "columnName": "DivisionCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "DivisionCode"
        },
        {
          "id": "extendedAttributes.divisionDescription",
          "label": "DivisionCsInteg2",
          "mandatory": false,
          "columnName": "DivisionCsInteg2",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "DivisionCsInteg2"
        },
        {
          "id": "extendedAttributes.catCode",
          "label": "BrandCatCsInteg",
          "mandatory": false,
          "columnName": "BrandCatCsInteg",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "BrandCatCsInteg"
        },
        {
          "id": "extendedAttributes.catDescription",
          "label": "BrandCatCsInteg2",
          "mandatory": false,
          "columnName": "BrandCatCsInteg2",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "BrandCatCsInteg2"
        },
        {
          "id": "extendedAttributes.packcode",
          "label": "BrandPackCsInteg",
          "mandatory": false,
          "columnName": "BrandPackCsInteg",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "BrandPackCsInteg"
        },
        {
          "id": "extendedAttributes.packDescription",
          "label": "BrandPackCsInteg2",
          "mandatory": false,
          "columnName": "BrandPackCsInteg2",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "BrandPackCsInteg2"
        }
      ]
    },
    "searchEnabledColumns": [
      "skuCode",
      "skuName",
      "brand"
    ]
  },
  {
    "id": "card-1747809770179",
    "icon": "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/Group 61721@2x-uUyPwMVsoyRI.png",
    "name": "Distributor Master",
    "formId": "9ebf0b90-68bf-4846-bd02-22abd631d764",
    "getAPI": "users",
    "actions": [
      "ChangeStatus",
      "ResetPassword",
      "Edit"
    ],
    "postAPI": "streamlet",
    "configAPI": "/users/id",
    "mandatory": false,
    "entityName": "DistributorMaster",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      },
      {
        "id": "logsAndReport",
        "label": "Logs and Reports"
      }
    ],
    "description": "Contains all information about all distributor within the system",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/ckcoeuat/images/DistributorNEW-nlPaNSqQJHVV.xlsx",
    "transformer": [
      {
        "entityName": "OutletDetails",
        "operationType": "insert",
        "transformerId": "Cavincare_Distributor_master_outlet_transformer"
      },
      {
        "entityName": "AccountInfo",
        "operationType": "insert",
        "transformerId": "Kevin_distributer_account_info_transformer"
      }
    ],
    "activeStatusKey": "",
    "supportedParams": "?flattenOut=true&Location=true&UserParent=true",
    "tableConfiguration": {
      "columns": [
        {
          "id": "extendedAttributes.companyCode",
          "label": "CompanyCode",
          "mandatory": false,
          "columnName": "CompanyCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "CompanyCode"
        },
        {
          "id": "loginId",
          "label": "DistCode",
          "mandatory": false,
          "columnName": "DistCode",
          "tableField": "loginId",
          "showInTable": true,
          "postMappingField": "DistCode"
        },
        {
          "id": "activeStatus",
          "label": "DistStatus",
          "mandatory": false,
          "columnName": "DistStatus",
          "tableField": "activeStatus",
          "showInTable": true,
          "postMappingField": "DistStatus"
        },
        {
          "id": "extendedAttributes.geoHierLevelCode",
          "label": "GeoHierLevelCode",
          "mandatory": false,
          "columnName": "GeoHierLevelCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "GeoHierLevelCode"
        },
        {
          "id": "GeoHierValueCode",
          "label": "GeoHierValueCode",
          "mandatory": false,
          "columnName": "GeoHierValueCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "GeoHierValueCode"
        },
        {
          "id": "extendedAttributes.SalesHierLevelCode",
          "label": "SalesHierLevelCode",
          "mandatory": false,
          "columnName": "SalesHierLevelCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "SalesHierLevelCode"
        },
        {
          "id": "extendedAttributes.SalesHierValueCode",
          "label": "SalesHierValueCode",
          "mandatory": false,
          "columnName": "SalesHierValueCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "SalesHierValueCode"
        },
        {
          "id": "extendedAttributes.supplyChainLevelCode",
          "label": "SupplyChainLevelCode",
          "mandatory": false,
          "columnName": "SupplyChainLevelCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "SupplyChainLevelCode"
        },
        {
          "id": "extendedAttributes.gstTinNumber",
          "label": "GstTinNumber",
          "mandatory": false,
          "columnName": "GstTinNumber",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "GstTinNumber"
        },
        {
          "id": "extendedAttributes.gstStateCode",
          "label": "GstStateCode",
          "mandatory": false,
          "columnName": "GstStateCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "GstStateCode"
        },
        {
          "id": "extendedAttributes.gstDistributorType",
          "label": "GstDistTypr",
          "mandatory": false,
          "columnName": "GstDistTypr",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "GstDistTypr"
        },
        {
          "id": "extendedAttributes.panNumber",
          "label": "PanNumber",
          "mandatory": false,
          "columnName": "PanNumber",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "PanNumber"
        },
        {
          "id": "address",
          "label": "Address1",
          "mandatory": false,
          "columnName": "Address1",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Address1"
        },
        {
          "id": "address",
          "label": "Address2",
          "mandatory": false,
          "columnName": "Address2",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Address2"
        },
        {
          "id": "address",
          "label": "Address3",
          "mandatory": false,
          "columnName": "Address3",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Address3"
        },
        {
          "id": "extendedAttributes.cityCode",
          "label": "CityCode",
          "mandatory": false,
          "columnName": "CityCode",
          "tableField": "extendedAttributes.cityCode",
          "showInTable": true,
          "postMappingField": "CityCode"
        },
        {
          "id": "extendedAttributes.gstStateCode",
          "label": "StateCode",
          "mandatory": false,
          "columnName": "StateCode",
          "tableField": "extendedAttributes.gstStateCode",
          "showInTable": true,
          "postMappingField": "StateCode"
        },
        {
          "id": "countryCode",
          "label": "CountyCode",
          "mandatory": false,
          "columnName": "CountyCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "CountyCode"
        },
        {
          "id": "name",
          "label": "ContactPerson",
          "mandatory": false,
          "columnName": "ContactPerson",
          "tableField": "name",
          "showInTable": true,
          "postMappingField": "ContactPerson"
        },
        {
          "id": "mobile",
          "label": "PhoneNumber",
          "mandatory": false,
          "columnName": "PhoneNumber",
          "tableField": "mobile",
          "showInTable": true,
          "postMappingField": "PhoneNumber"
        },
        {
          "id": "extendedAttributes.postalCode",
          "label": "PostalCode",
          "mandatory": false,
          "columnName": "PostalCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "PostalCode"
        },
        {
          "id": "email",
          "label": "Email",
          "mandatory": false,
          "columnName": "Email",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Email"
        },
        {
          "id": "extendedAttributes.distChannelCode",
          "label": "DistChannelCode",
          "mandatory": false,
          "columnName": "DistChannelCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "DistChannelCode"
        },
        {
          "id": "extendedAttributes.distType",
          "label": "DistType",
          "mandatory": false,
          "columnName": "DistType",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "DistType"
        },
        {
          "id": "extendedAttributes.catCode",
          "label": "DistCatCode",
          "mandatory": false,
          "columnName": "DistCatCode",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "DistCatCode"
        },
        {
          "id": "extendedAttributes.whCode",
          "label": "DefaultSupplierCode",
          "mandatory": false,
          "columnName": "DefaultSupplierCode",
          "tableField": "extendedAttributes.whCode",
          "showInTable": true,
          "postMappingField": "DefaultSupplierCode"
        },
        {
          "id": "prodauthcode",
          "label": "DistDivision",
          "mandatory": false,
          "columnName": "DistDivision",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "DistDivision"
        }
      ]
    }
  },
  {
    "id": "card-1747810395137",
    "icon": "https://d2nvw4ekms3xzy.cloudfront.net/hccbckinduat/images/price-tuFtriOFRNJV.png",
    "name": "Price Master",
    "formId": "e4e2b904-7254-4a88-b31f-302de3349362",
    "getAPI": "/api",
    "actions": [],
    "postAPI": "streamlet",
    "configAPI": "priceMaster",
    "mandatory": false,
    "entityName": "priceMaster",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      },
      {
        "id": "logsAndReport",
        "label": "Logs and Reports"
      }
    ],
    "description": "Contains detailed information about price data within the system.",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/ckcoeuat/images/ProductMetadata-WXmKhGAoCciX (3)-hpEiGlgnZmNv.xlsx",
    "transformer": [
      {
        "entityName": "ProductMetaData",
        "transformerId": "Cavincare_Price_Master_transformer"
      },
      {
        "entityName": "ProductMetaData",
        "operationType": "",
        "transformerId": "Cavincare_Price_Master_PriceList_transformer",
        "preprocessValidationExcludeGroup": ""
      }
    ],
    "activeStatusKey": "",
    "supportedParams": "?flattenOut=true",
    "tableConfiguration": {
      "columns": [
        {
          "id": "BatchId",
          "label": "BatchId",
          "mandatory": false,
          "columnName": "BatchId",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "skuCode",
          "label": "skuCode",
          "mandatory": false,
          "columnName": "skuCode",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "activeStatus",
          "label": "activeStatus",
          "mandatory": false,
          "columnName": "activeStatus",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "mrp",
          "label": "mrp",
          "mandatory": false,
          "columnName": "mrp",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "casePtr",
          "label": "casePtr",
          "mandatory": false,
          "columnName": "casePtr",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "packPtr",
          "label": "packPtr",
          "mandatory": false,
          "columnName": "packPtr",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "otherUnitPtr",
          "label": "otherUnitPtr",
          "mandatory": false,
          "columnName": "otherUnitPtr",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "loginId",
          "label": "loginId",
          "mandatory": false,
          "columnName": "loginId",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "channel",
          "label": "channel",
          "mandatory": false,
          "columnName": "channel",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "fromDate",
          "label": "fromDate",
          "mandatory": false,
          "columnName": "fromDate",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "extendedattributes1",
          "label": "extendedattributes1",
          "mandatory": false,
          "columnName": "extendedattributes1",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "extendedattributes2",
          "label": "extendedattributes2",
          "mandatory": false,
          "columnName": "extendedattributes2",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "extendedattributes3",
          "label": "extendedattributes3",
          "mandatory": false,
          "columnName": "extendedattributes3",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "extendedattributes4",
          "label": "extendedattributes4",
          "mandatory": false,
          "columnName": "extendedattributes4",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "extendedattributes5",
          "label": "extendedattributes5",
          "mandatory": false,
          "columnName": "extendedattributes5",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        }
      ]
    }
  },
  {
    "id": "card-1747812206076",
    "icon": "https://d2nvw4ekms3xzy.cloudfront.net/hccbckinduat/images/vehicle-MTueUXHGfpAK.png",
    "name": "Vehicle Master",
    "formId": "9445b7fd-83b1-4aae-a60a-1a50fd6fca44",
    "getAPI": "models/vehicleMaster",
    "actions": [],
    "postAPI": "streamlet",
    "configAPI": "/vehicleInfo/id",
    "mandatory": false,
    "entityName": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      },
      {
        "id": "logsAndReport",
        "label": "Logs and Reports"
      }
    ],
    "description": "This master contains fields based on vehicle information",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/ckcoeuat/images/VehicleMDMUpload-CEREAPTkwTVF (6)-TLiMBJmsBjXx.xlsx",
    "transformer": [
      {
        "entityName": "VehicleInfo",
        "transformerId": "dms_vehicle_master_transformer"
      }
    ],
    "activeStatusKey": "",
    "supportedParams": "?flattenOut=true",
    "tableConfiguration": {
      "columns": [
        {
          "id": "Distributor Id",
          "label": "Distributor Id",
          "mandatory": false,
          "columnName": "Distributor Id",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Distributor Id"
        },
        {
          "id": "Vehicle ID (Key)",
          "label": "Vehicle ID (Key)",
          "mandatory": false,
          "columnName": "Vehicle ID (Key)",
          "tableField": "Vehicle ID (Key)",
          "showInTable": true,
          "postMappingField": "Vehicle ID (Key)"
        },
        {
          "id": "Vehicle Type",
          "label": "Vehicle Type",
          "mandatory": false,
          "columnName": "Vehicle Type",
          "tableField": "Vehicle Type",
          "showInTable": true,
          "postMappingField": "Vehicle Type"
        },
        {
          "id": "Vehicle Length (FT)",
          "label": "Vehicle Length (FT)",
          "mandatory": false,
          "columnName": "Vehicle Length (FT)",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Vehicle Length (FT)"
        },
        {
          "id": "Vehicle Width (FT)",
          "label": "Vehicle Width (FT)",
          "mandatory": false,
          "columnName": "Vehicle Width (FT)",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Vehicle Width (FT)"
        },
        {
          "id": "Vehicle Height (FT)",
          "label": "Vehicle Height (FT)",
          "mandatory": false,
          "columnName": "Vehicle Height (FT)",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Vehicle Height (FT)"
        },
        {
          "id": "Vehicle Load Capacity (KG)",
          "label": "Vehicle Load Capacity (KG)",
          "mandatory": false,
          "columnName": "Vehicle Load Capacity (KG)",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Vehicle Load Capacity (KG)"
        },
        {
          "id": "Vehicle Capacity (CU.FT)",
          "label": "Vehicle Capacity (CU.FT)",
          "mandatory": false,
          "columnName": "Vehicle Capacity (CU.FT)",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Vehicle Capacity (CU.FT)"
        },
        {
          "id": "Registration Number",
          "label": "Registration Number",
          "mandatory": false,
          "columnName": "Registration Number",
          "tableField": "Registration Number",
          "showInTable": true,
          "postMappingField": "Registration Number"
        },
        {
          "id": "Current Status",
          "label": "Current Status",
          "mandatory": false,
          "columnName": "Current Status",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Current Status"
        },
        {
          "id": "GPS Tracking",
          "label": "GPS Tracking",
          "mandatory": false,
          "columnName": "GPS Tracking",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "GPS Tracking"
        },
        {
          "id": "Purchase Date",
          "label": "Purchase Date",
          "mandatory": false,
          "columnName": "Purchase Date",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Purchase Date"
        },
        {
          "id": "Insurance ID",
          "label": "Insurance ID",
          "mandatory": false,
          "columnName": "Insurance ID",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Insurance ID"
        },
        {
          "id": "Insurance Validity Date",
          "label": "Insurance Validity Date",
          "mandatory": false,
          "columnName": "Insurance Validity Date",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Insurance Validity Date"
        },
        {
          "id": "Fuel Type",
          "label": "Fuel Type",
          "mandatory": false,
          "columnName": "Fuel Type",
          "tableField": "",
          "showInTable": false,
          "postMappingField": "Fuel Type"
        }
      ]
    }
  },
  {
    "id": "card-1747812336136",
    "icon": "https://d2nvw4ekms3xzy.cloudfront.net/hccbckinduat/images/staff-mFvPLisxfICA.png",
    "name": "Staff Master",
    "formId": "18c45c27-30fc-4572-94fd-b823b3607f8d",
    "getAPI": "models/staffMaster",
    "actions": [],
    "postAPI": "streamlet",
    "configAPI": "staffMaster",
    "mandatory": false,
    "entityName": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      },
      {
        "id": "logsAndReport",
        "label": "Logs and Reports"
      }
    ],
    "description": "This master contains fields based on staff information",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/cokenpuat/images/staff_master_data (1)-XTmspAunOoQM.xlsx",
    "transformer": [
      {
        "entityName": "GenericEntity",
        "transformerId": "dms_staff_master_transformer"
      }
    ],
    "activeStatusKey": "",
    "tableConfiguration": {
      "columns": [
        {
          "id": "key1",
          "label": "Staff Code (Key)",
          "mandatory": false,
          "columnName": "Staff Code (Key)",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "key2",
          "label": "Staff Designation",
          "mandatory": false,
          "columnName": "Staff Designation",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "name",
          "label": "Staff Name",
          "mandatory": false,
          "columnName": "Staff Name",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "key3",
          "label": "Staff Contact No",
          "mandatory": false,
          "columnName": "Staff Contact No",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "email",
          "label": "Staff Email",
          "mandatory": false,
          "columnName": "Staff Email",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "key4",
          "label": "Staff Asset",
          "mandatory": false,
          "columnName": "Staff Asset",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "key5",
          "label": "Staff Asset Id",
          "mandatory": false,
          "columnName": "Staff Asset Id",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "Date Of Joining",
          "label": "Date Of Joining",
          "mandatory": false,
          "columnName": "Date Of Joining",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        }
      ]
    }
  },
  {
    "id": "card-1747813430387",
    "icon": "https://d2nvw4ekms3xzy.cloudfront.net/hccbckinduat/images/pjp-rVJVRnSpFTdj.png",
    "name": "PJP Master",
    "formId": "abed71ba-3dae-451c-bb64-e30a04022594",
    "getAPI": "/test",
    "actions": [],
    "postAPI": "streamlet",
    "configAPI": "pjpMaster",
    "mandatory": false,
    "entityName": "pjpMaster",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      },
      {
        "id": "logsAndReport",
        "label": "Logs and Reports"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      }
    ],
    "description": "Contains visit PJP information such as month, year, & planned visit day.",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/cokenpuat/images/PJP_DMS-kNpJlKkhPhGK.xlsx",
    "transformer": [
      {
        "entityName": "User",
        "transformerId": "dms_mdm_salesrep_user_transformer"
      },
      {
        "entityName": "DeliveryPJP",
        "transformerId": "dms_mdm_deliverypjp_transformer"
      }
    ],
    "activeStatusKey": "",
    "tableConfiguration": {
      "columns": [
        {
          "id": "outletcode",
          "label": "OutletCode",
          "mandatory": false,
          "columnName": "OutletCode",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "loginid",
          "label": "LoginID",
          "mandatory": false,
          "columnName": "LoginID",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "month",
          "label": "Month",
          "mandatory": false,
          "columnName": "Month",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "year",
          "label": "Year",
          "mandatory": false,
          "columnName": "Year",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "day_and_frequency1",
          "label": "Week1",
          "mandatory": false,
          "columnName": "Week1",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "day_and_frequency2",
          "label": "Week2",
          "mandatory": false,
          "columnName": "Week2",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "day_and_frequency3",
          "label": "Week3",
          "mandatory": false,
          "columnName": "Week3",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "day_and_frequency4",
          "label": "Week4",
          "mandatory": false,
          "columnName": "Week4",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "day_and_frequency5",
          "label": "Week5",
          "mandatory": false,
          "columnName": "Week5",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "day_and_frequency",
          "label": "Week6",
          "mandatory": false,
          "columnName": "Week6",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "beat",
          "label": "Beat ID",
          "mandatory": false,
          "columnName": "Beat ID",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "beatName",
          "label": "Beat Name",
          "mandatory": false,
          "columnName": "Beat Name",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "outletName",
          "label": "Outlet Name",
          "mandatory": false,
          "columnName": "Outlet Name",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "supplier",
          "label": "Distributor ID",
          "mandatory": false,
          "columnName": "Distributor ID",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        }
      ]
    }
  },
  {
    "id": "card-1747813506151",
    "icon": "https://d2nvw4ekms3xzy.cloudfront.net/hccbckinduat/images/tax-ZGdVyuMSvjIH.png",
    "name": "Tax Master",
    "formId": "1eb2b471-8b70-476f-8b2e-5ca5ccb38847",
    "getAPI": "/test",
    "actions": [],
    "postAPI": "streamlet",
    "configAPI": "taxMaster",
    "mandatory": false,
    "entityName": "taxMaster",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      }
    ],
    "description": "Contains detailed information about tax data within the system.",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/cokenpuat/images/Tax Master 1401-pdZlDfJQXNqr.xlsx",
    "transformer": [
      {
        "entityName": "Test",
        "operationType": "Test",
        "transformerId": "Test"
      }
    ],
    "activeStatusKey": "",
    "tableConfiguration": {
      "columns": [
        {
          "id": "HSN code (Key)",
          "label": "HSN code (Key)",
          "mandatory": false,
          "columnName": "HSN code (Key)",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "CGST (%)",
          "label": "CGST (%)",
          "mandatory": false,
          "columnName": "CGST (%)",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "SGST/UGST (%)",
          "label": "SGST/UGST (%)",
          "mandatory": false,
          "columnName": "SGST/UGST (%)",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "IGST (%)",
          "label": "IGST (%)",
          "mandatory": false,
          "columnName": "IGST (%)",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "CESS (%)",
          "label": "CESS (%)",
          "mandatory": false,
          "columnName": "CESS (%)",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        }
      ]
    }
  },
  {
    "id": "card-1747813566832",
    "icon": "",
    "name": "Prod Auth",
    "formId": "681ebd95-1677-4617-b523-a455c501e519",
    "getAPI": "/test",
    "actions": [],
    "postAPI": "streamlet",
    "configAPI": "prodAuth",
    "mandatory": false,
    "entityName": "prodAuth",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      },
      {
        "id": "masterDownload",
        "label": "Master Download"
      }
    ],
    "description": "",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/cokenpuat/images/ProdAuthCodeMappingTemplate-MGmjgxjEwdlz.xlsx",
    "transformer": [
      {
        "entityName": "Test",
        "operationType": "Test",
        "transformerId": "Test"
      }
    ],
    "activeStatusKey": "",
    "tableConfiguration": {
      "columns": [
        {
          "id": "prodAuthCode",
          "label": "prodAuthCode",
          "mandatory": false,
          "columnName": "prodAuthCode",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "skuCode",
          "label": "skuCode",
          "mandatory": false,
          "columnName": "skuCode",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        }
      ]
    }
  },
  {
    "id": "card-1747813634264",
    "icon": "https://d2nvw4ekms3xzy.cloudfront.net/hccbckinduat/images/delivery-XczyqiBCPdic.png",
    "name": "Delivery Route Master",
    "formId": "846fdbe9-0f40-4287-849b-08b03f78fc8a",
    "getAPI": "v1/route",
    "actions": [],
    "postAPI": "streamlet",
    "configAPI": "routeInfo",
    "mandatory": false,
    "entityName": "routeInfo",
    "menuOption": [
      {
        "id": "import",
        "label": "Import"
      },
      {
        "id": "viewsAndEdit",
        "label": "View and Edit"
      },
      {
        "id": "masterDownload",
        "label": "Master Download"
      }
    ],
    "description": "Contains delivery route information",
    "templateUrl": "https://d2nvw4ekms3xzy.cloudfront.net/cokenpuat/images/delivery route master-nxUeooaNpAWf.xlsx",
    "transformer": [
      {
        "entityName": "RouteInfo",
        "transformerId": "route_info_master_data_transformer"
      }
    ],
    "activeStatusKey": "",
    "tableConfiguration": {
      "columns": [
        {
          "id": "Delivery Route No",
          "label": "Delivery Route No",
          "mandatory": false,
          "columnName": "Delivery Route No",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "Outlet Code",
          "label": "Outlet Code",
          "mandatory": false,
          "columnName": "Outlet Code",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "Salesman code",
          "label": "Salesman code",
          "mandatory": false,
          "columnName": "Salesman code",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "Sales route",
          "label": "Sales route",
          "mandatory": false,
          "columnName": "Sales route",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "Salesrep",
          "label": "Salesrep",
          "mandatory": false,
          "columnName": "Salesrep",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "Sales Mode",
          "label": "Sales Mode",
          "mandatory": false,
          "columnName": "Sales Mode",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "Salesrep code",
          "label": "Salesrep code",
          "mandatory": false,
          "columnName": "Salesrep code",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "Distributor Code",
          "label": "Distributor Code",
          "mandatory": false,
          "columnName": "Distributor Code",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        },
        {
          "id": "prod auth",
          "label": "prod auth",
          "mandatory": false,
          "columnName": "prod auth",
          "tableField": "",
          "showInTable": true,
          "postMappingField": ""
        }
      ]
    }
  }
]
;

export const formConfig: any[]=[
  {
    "value": [
      {
        "api": "/productActivity",
        "formId": "4ea0bf7f-92b8-4234-b687-5834acd17e14",
        "formName": "merchandising",
        "sections": [
          {
            "id": "section-1",
            "name": "Merchandising",
            "widgets": [
              {
                "id": "e05f26e7-475d-4e41-8d2b-4fb9db990412",
                "config": {
                  "list": [
                    "POSM Management",
                    "Window Visibility",
                    "Endcap Visibility",
                    "Sampling Activity",
                    "Any Other Activation"
                  ],
                  "label": "Purpose of Merchandising",
                  "checked": [],
                  "required": true
                },
                "widgetType": "checkbox",
                "mappedApiField": "hierarchy"
              },
              {
                "id": "76119376-d2ab-4a68-9024-d3832c08b39b",
                "config": {
                  "label": "After Merchandising",
                  "value": "",
                  "camera": true,
                  "gallery": true,
                  "required": true
                },
                "widgetType": "camera",
                "mappedApiField": "images"
              },
              {
                "id": "98ee13c2-a010-4cb8-b99d-c3db7d055574",
                "config": {
                  "label": "Remarks",
                  "value": "",
                  "placeholder": "Write here..."
                },
                "widgetType": "textarea",
                "mappedApiField": "other",
                "extendedMappedApiFieldName": "remarks"
              }
            ]
          }
        ],
        "buttonLabel": "Send"
      },
      {
        "api": "/outletActivity",
        "formId": "ba2b9797-ac22-420e-8f6c-a1ee5cb61fb4",
        "formName": "form 1",
        "sections": [
          {
            "id": "section-1",
            "name": "Untitled Section 1",
            "widgets": [
              {
                "id": "f28122db-5c04-42f4-9397-f3fa9844a9e3",
                "config": {
                  "label": "Custom text...",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "password"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "widgetType": "text-input",
                "mappedApiField": "name"
              },
              {
                "id": "c2a5cc81-fdf9-403f-a6ca-3700d3cce10b",
                "config": {
                  "label": "Date Range",
                  "endDate": "",
                  "required": true,
                  "startDate": "",
                  "difference": true
                },
                "widgetType": "ranged-date",
                "mappedApiField": "{\"startDate\":\"startTime\",\"endDate\":\"endTime\"}"
              },
              {
                "id": "55286b8e-471f-49f2-a345-7167a5b2c22d",
                "config": {
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3",
                    "kjgdhjdsgfhjd"
                  ],
                  "label": "Check this box",
                  "checked": [],
                  "required": false
                },
                "widgetType": "checkbox",
                "mappedApiField": "other",
                "extendedMappedApiFieldName": "g"
              }
            ]
          }
        ],
        "buttonLabel": "Submit"
      },
      {
        "api": "/products",
        "formId": "a2fceea0-6160-4e90-841b-90ff954f9255",
        "formName": "Outlet Form",
        "sections": [
          {
            "id": "section-1",
            "name": "User Identification",
            "widgets": [
              {
                "id": "6eb9d8dc-1d7e-4b4e-8965-13342b76d963",
                "config": {
                  "label": "ThirdPartyEmployeeCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "ThirdPartyEmployeeCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.thirdPartyEmployeeCode"
              },
              {
                "id": "9262d41b-b541-4b8e-9830-9e6254429de5",
                "config": {
                  "label": "salesmantype",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "salesmantype",
                "widgetType": "text-input",
                "mappedApiField": "contactType"
              },
              {
                "id": "0bdad143-9d85-4e64-9534-963ef99a9857",
                "config": {
                  "label": "email",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": false,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "columnName": "email",
                "widgetType": "text-input",
                "mappedApiField": "email",
                "extendedMappedApiFieldName": "e"
              },
              {
                "id": "dcab01e4-eaf0-449f-8b71-1e0c827159cb",
                "config": {
                  "label": "loginid",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "columnName": "loginid",
                "widgetType": "text-input",
                "mappedApiField": "loginId"
              },
              {
                "id": "9b34fb89-3f51-47b4-a707-5986c051bedb",
                "config": {
                  "label": "name",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "columnName": "name",
                "widgetType": "text-input",
                "mappedApiField": "name"
              },
              {
                "id": "3c705d96-b4d5-47c5-9980-e7dc3ccdbf75",
                "config": {
                  "label": "mobile",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 16,
                  "regexValidation": ""
                },
                "columnName": "mobile",
                "widgetType": "text-input",
                "mappedApiField": "mobile"
              }
            ]
          },
          {
            "id": "212a958c-5f5a-4193-880a-db858873deb5",
            "name": "Location",
            "widgets": [
              {
                "id": "2ba10549-1b76-4e0f-b969-a560b06b7806",
                "config": {
                  "label": "region",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "50",
                  "regexValidation": ""
                },
                "sectionId": "212a958c-5f5a-4193-880a-db858873deb5",
                "columnName": "region",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.region"
              },
              {
                "id": "3a7aceda-79de-4d14-b720-ee7166b210e5",
                "config": {
                  "label": "country",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "40",
                  "regexValidation": ""
                },
                "sectionId": "212a958c-5f5a-4193-880a-db858873deb5",
                "columnName": "country",
                "widgetType": "text-input",
                "mappedApiField": "Location.country"
              }
            ]
          },
          {
            "id": "5863bf68-5257-4a40-949b-c87797c1965d",
            "name": "Status",
            "widgets": [
              {
                "id": "326aa395-0482-492a-8a4d-d075258aa069",
                "config": {
                  "list": [
                    "Active",
                    "Inactive"
                  ],
                  "label": "active",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": true,
                  "defaultOption": "Option 1"
                },
                "sectionId": "5863bf68-5257-4a40-949b-c87797c1965d",
                "columnName": "active",
                "widgetType": "dropdown",
                "mappedApiField": "activeStatus"
              }
            ]
          },
          {
            "id": "9f4e62ed-5c83-456a-b94f-948a30322fe3",
            "name": "Role and Hierarchy",
            "widgets": [
              {
                "id": "be005df9-1e30-4887-826e-1a3681d81f40",
                "config": {
                  "label": "designation",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "9f4e62ed-5c83-456a-b94f-948a30322fe3",
                "columnName": "designation",
                "widgetType": "text-input",
                "mappedApiField": "designation.0.designation"
              },
              {
                "id": "7fe31dbf-2a40-4a50-980d-024613a948f0",
                "config": {
                  "label": "parentid-1",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "9f4e62ed-5c83-456a-b94f-948a30322fe3",
                "columnName": "parentid-1",
                "widgetType": "text-input",
                "mappedApiField": "UserParent.parent"
              }
            ]
          },
          {
            "id": "4682c20d-0f4a-41ea-a883-10ae62ca78cb",
            "name": "Employment Details",
            "widgets": [
              {
                "id": "351ea1c8-1d1c-4117-a1f5-d1b7849baef0",
                "config": {
                  "label": "replacementfor",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "4682c20d-0f4a-41ea-a883-10ae62ca78cb",
                "columnName": "replacementfor",
                "widgetType": "text-input",
                "mappedApiField": "replacementfor"
              },
              {
                "id": "1d138e78-98c5-4886-8968-053231aed6d1",
                "config": {
                  "label": "dailyallowance",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "4682c20d-0f4a-41ea-a883-10ae62ca78cb",
                "columnName": "dailyallowance",
                "widgetType": "text-input",
                "mappedApiField": "dailyallowance"
              },
              {
                "id": "65672564-9f79-4a01-aae1-f45646e9bd61",
                "config": {
                  "label": "salary",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "4682c20d-0f4a-41ea-a883-10ae62ca78cb",
                "columnName": "salary",
                "widgetType": "text-input",
                "mappedApiField": "salary"
              },
              {
                "id": "27ab9113-6511-4eb1-9cad-bb2099ef9e7f",
                "config": {
                  "hint": "",
                  "label": "dob",
                  "editable": true,
                  "required": true,
                  "defaultDate": ""
                },
                "sectionId": "4682c20d-0f4a-41ea-a883-10ae62ca78cb",
                "columnName": "dob",
                "widgetType": "date-picker",
                "mappedApiField": "dob"
              },
              {
                "id": "70469722-ffcb-409f-9aaf-a1fcd59c0262",
                "config": {
                  "hint": "",
                  "label": "doj",
                  "editable": true,
                  "required": true,
                  "defaultDate": ""
                },
                "sectionId": "4682c20d-0f4a-41ea-a883-10ae62ca78cb",
                "columnName": "doj",
                "widgetType": "date-picker",
                "mappedApiField": "doa"
              }
            ]
          },
          {
            "id": "3e446533-8805-4df2-abd5-b7e8d61ee815",
            "name": "Others",
            "widgets": [
              {
                "id": "6e4b9a10-7f10-4fa0-a177-281b691ac17d",
                "config": {
                  "label": "beatLockingType",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "3e446533-8805-4df2-abd5-b7e8d61ee815",
                "columnName": "beatLockingType",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.beatLockingType"
              },
              {
                "id": "b56fcf52-4ee1-445b-a01c-df5098a76983",
                "config": {
                  "label": "prodauth",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "3e446533-8805-4df2-abd5-b7e8d61ee815",
                "columnName": "prodauth",
                "widgetType": "text-input",
                "mappedApiField": "prodauthcode"
              }
            ]
          }
        ],
        "buttonLabel": "Submit"
      },
      {
        "api": "/users",
        "formId": "02432242-d189-4016-b4e4-b2ca1d803c40",
        "formName": "outlet master ",
        "sections": [
          {
            "id": "section-1",
            "name": "outlet master ",
            "widgets": [
              {
                "id": "76f5ed91-b728-4d37-8002-3dd083de6bf9",
                "config": {
                  "label": "Employee Id",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "widgetType": "text-input",
                "mappedApiField": "id"
              }
            ]
          }
        ],
        "buttonLabel": "Employee Id"
      },
      {
        "api": "/users",
        "formId": "d7b264d7-983f-44e2-a368-e086f99987bc",
        "formName": "Outlet Master",
        "sections": [
          {
            "id": "section-1",
            "name": "Outlet Master",
            "widgets": [
              {
                "id": "5bc5fede-594c-4470-b2b4-6ad6b205bace",
                "config": {
                  "label": "HQID",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "widgetType": "text-input",
                "mappedApiField": "id"
              },
              {
                "id": "3128eb87-c0e0-4afe-bc23-528cf9eedbd4",
                "config": {
                  "label": "Employee ID",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "widgetType": "text-input",
                "mappedApiField": "loginId"
              },
              {
                "id": "9a79910c-9de9-48e8-a071-6b2a41f929a0",
                "config": {
                  "label": "Employee Name",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "widgetType": "text-input",
                "mappedApiField": "name"
              },
              {
                "id": "66ad23a3-d2a8-4d69-97f2-d0cb4fbed44f",
                "config": {
                  "label": "Mobile No",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "widgetType": "text-input",
                "mappedApiField": "mobile"
              },
              {
                "id": "e63d77b6-6077-4eab-a0c7-99bf5d2db6b7",
                "config": {
                  "label": "Status",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "widgetType": "text-input",
                "mappedApiField": "activeStatus"
              },
              {
                "id": "b81a1d38-5324-4e79-8542-44d837b41b7f",
                "config": {
                  "label": "Designation",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "widgetType": "text-input",
                "mappedApiField": "designation"
              },
              {
                "id": "192a0505-dfaa-49d8-bd14-1c1693ad7968",
                "config": {
                  "label": "Email ID",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "widgetType": "text-input",
                "mappedApiField": "email"
              }
            ]
          }
        ],
        "buttonLabel": "Outlet "
      },
      {
        "api": "/productActivity",
        "formId": "b0a89b3a-1644-4e37-990c-eebd77747963",
        "formName": "product master",
        "sections": [
          {
            "id": "43dee620-ba07-4451-95ff-92d2e1f7bfe1",
            "name": "Product Identification",
            "widgets": [
              {
                "id": "2964945b-8ee9-4a6f-b7ef-3c49086cc0c4",
                "config": {
                  "label": "ProductEanCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "43dee620-ba07-4451-95ff-92d2e1f7bfe1",
                "columnName": "ProductEanCode",
                "widgetType": "text-input",
                "mappedApiField": "eanNumber"
              },
              {
                "id": "bc4df947-b9b8-42c4-8bd3-d0a4b350d38c",
                "config": {
                  "label": "ProdHierValueCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "43dee620-ba07-4451-95ff-92d2e1f7bfe1",
                "columnName": "ProdHierValueCode",
                "widgetType": "text-input",
                "mappedApiField": "otherProduct"
              },
              {
                "id": "8487064a-ce8c-4234-9bcf-5cc695b6f70e",
                "config": {
                  "label": "ProdHierLevelCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "43dee620-ba07-4451-95ff-92d2e1f7bfe1",
                "columnName": "ProdHierLevelCode",
                "widgetType": "text-input",
                "mappedApiField": "ProdHierLevelCode"
              },
              {
                "id": "8b68c22b-8fb2-4d24-a2bc-92d63a27e5be",
                "config": {
                  "label": "CompanyProductCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "43dee620-ba07-4451-95ff-92d2e1f7bfe1",
                "columnName": "CompanyProductCode",
                "widgetType": "text-input",
                "mappedApiField": "skuCode"
              },
              {
                "id": "3e10db33-47e2-4bfe-b3ae-30cadfbdc6c7",
                "config": {
                  "label": "ProductCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "43dee620-ba07-4451-95ff-92d2e1f7bfe1",
                "columnName": "ProductCode",
                "widgetType": "text-input",
                "mappedApiField": "productCode"
              }
            ]
          },
          {
            "id": "56373156-0941-4334-bec3-35d37c20c22c",
            "name": "Product Attributes/Filters",
            "widgets": [
              {
                "id": "66b77845-1273-4565-b131-bc78e1332b2f",
                "config": {
                  "label": "ProductType",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "56373156-0941-4334-bec3-35d37c20c22c",
                "columnName": "ProductType",
                "widgetType": "text-input",
                "mappedApiField": "itemType"
              },
              {
                "id": "b27b399c-edd9-4fb3-8dbc-998dffaf7154",
                "config": {
                  "label": "BrandPackCsInteg2",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "56373156-0941-4334-bec3-35d37c20c22c",
                "columnName": "BrandPackCsInteg2",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.packDescription"
              },
              {
                "id": "35387f04-8ba0-4792-8628-c9126ab67e65",
                "config": {
                  "label": "BrandPackCsInteg",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "56373156-0941-4334-bec3-35d37c20c22c",
                "columnName": "BrandPackCsInteg",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.packcode"
              },
              {
                "id": "8eefda4d-a5b7-4b93-b68b-19599ac72fdc",
                "config": {
                  "label": "BrandCatCsInteg2",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "56373156-0941-4334-bec3-35d37c20c22c",
                "columnName": "BrandCatCsInteg2",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.catDescription"
              },
              {
                "id": "c51cb557-e3b8-49c5-84ed-1954f68ea504",
                "config": {
                  "label": "BrandCatCsInteg",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "56373156-0941-4334-bec3-35d37c20c22c",
                "columnName": "BrandCatCsInteg",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.catCode"
              },
              {
                "id": "0adb843f-dc80-4a7e-8399-2b825dab6581",
                "config": {
                  "label": "DivisionCsInteg2",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "56373156-0941-4334-bec3-35d37c20c22c",
                "columnName": "DivisionCsInteg2",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.divisionDescription"
              },
              {
                "id": "5928d5e2-065c-4d7a-8270-c68af7779630",
                "config": {
                  "label": "DivisionCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "56373156-0941-4334-bec3-35d37c20c22c",
                "columnName": "DivisionCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.division"
              },
              {
                "id": "55f8cd72-f8f7-4ced-9162-4f0f0c5fed9a",
                "config": {
                  "label": "ProductShortName",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "56373156-0941-4334-bec3-35d37c20c22c",
                "columnName": "ProductShortName",
                "widgetType": "text-input",
                "mappedApiField": "skuName"
              },
              {
                "id": "fe381fa3-869c-41b9-af11-c338154e40d5",
                "config": {
                  "label": "ProductName",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "56373156-0941-4334-bec3-35d37c20c22c",
                "columnName": "ProductName",
                "widgetType": "text-input",
                "mappedApiField": "skuDescription"
              },
              {
                "id": "c6796b68-2025-42f9-bdc6-e9bd0d54de8f",
                "config": {
                  "label": "IsDrugProduct",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "56373156-0941-4334-bec3-35d37c20c22c",
                "columnName": "IsDrugProduct",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.isDrugProduct"
              }
            ]
          },
          {
            "id": "91a1a3f7-6ab4-4f5b-8743-3b0eac453716",
            "name": "Pricing and Tax",
            "widgets": [
              {
                "id": "0de77d3b-a965-4e8d-81a4-388ba201f364",
                "config": {
                  "label": "HsnCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "91a1a3f7-6ab4-4f5b-8743-3b0eac453716",
                "columnName": "HsnCode",
                "widgetType": "text-input",
                "mappedApiField": "tariffCode"
              },
              {
                "id": "354496ff-a499-4023-9793-648609c896f5",
                "config": {
                  "label": "HsnName",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "91a1a3f7-6ab4-4f5b-8743-3b0eac453716",
                "columnName": "HsnName",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.hsnname"
              }
            ]
          },
          {
            "id": "390ee1ab-3931-4f9e-9914-842ac8f155bc",
            "name": "Weight and Volume",
            "widgets": [
              {
                "id": "ac1c9b61-cf0c-4de2-8de5-77bfaa0d5f08",
                "config": {
                  "label": "ProductWeightType",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "390ee1ab-3931-4f9e-9914-842ac8f155bc",
                "columnName": "ProductWeightType",
                "widgetType": "text-input",
                "mappedApiField": "skuPcWeightUom"
              },
              {
                "id": "9144301f-b450-40c5-8479-30aa62625b76",
                "config": {
                  "label": "ProductNetWeight",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "390ee1ab-3931-4f9e-9914-842ac8f155bc",
                "columnName": "ProductNetWeight",
                "widgetType": "text-input",
                "mappedApiField": "skuPieceWeight"
              }
            ]
          },
          {
            "id": "3fad674a-69ed-4b52-94c9-1ae1d9fe0015",
            "name": "Handling and Logistics",
            "widgets": [
              {
                "id": "e84aa6c0-02f4-4fc5-9727-c9ecc3bc240a",
                "config": {
                  "label": "ShelfLife",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "3fad674a-69ed-4b52-94c9-1ae1d9fe0015",
                "columnName": "ShelfLife",
                "widgetType": "text-input",
                "mappedApiField": "shelfLifeDays"
              }
            ]
          },
          {
            "id": "ca1bd1f4-c870-4a3b-bd3d-afb20477b706",
            "name": "Status",
            "widgets": [
              {
                "id": "d3548795-9f2e-4c17-9bcb-b949ad2a894b",
                "config": {
                  "label": "IsActive",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "ca1bd1f4-c870-4a3b-bd3d-afb20477b706",
                "columnName": "IsActive",
                "widgetType": "text-input",
                "mappedApiField": "activeStatus"
              }
            ]
          }
        ],
        "buttonLabel": "product "
      },
      {
        "api": "/users",
        "formId": "9ebf0b90-68bf-4846-bd02-22abd631d764",
        "formName": "distributor master ",
        "sections": [
          {
            "id": "section-1",
            "name": "Distributor Identification",
            "widgets": [
              {
                "id": "a693da01-19ec-4587-877e-14a853261726",
                "config": {
                  "label": "DistChannelCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "DistChannelCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.distChannelCode"
              },
              {
                "id": "2a1e24ed-6799-4abd-a815-dcc9214ba9b0",
                "config": {
                  "label": "PostalCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "PostalCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.postalCode"
              },
              {
                "id": "045b9bf5-f033-4324-8c9c-8eaa63cf6d10",
                "config": {
                  "label": "PhoneNumber",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "PhoneNumber",
                "widgetType": "text-input",
                "mappedApiField": "mobile"
              },
              {
                "id": "5e4d6040-8bac-4d85-a98d-96158d9e1d3c",
                "config": {
                  "label": "ContactPerson",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "ContactPerson",
                "widgetType": "text-input",
                "mappedApiField": "name"
              },
              {
                "id": "83f74221-b0d3-4fbc-8170-696d04e7f962",
                "config": {
                  "label": "DistCatCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "DistCatCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.catCode"
              },
              {
                "id": "7490666e-a5ce-48cc-be4f-9a552d3c6f48",
                "config": {
                  "label": "DistType",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "DistType",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.distType"
              },
              {
                "id": "eb68bcb9-9b43-4342-acec-94f92dde6d25",
                "config": {
                  "list": [
                    "C",
                    "c",
                    "Y",
                    "y",
                    "N",
                    "n",
                    "Active",
                    "Inactive"
                  ],
                  "label": "DistStatus",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": true,
                  "defaultOption": "Option 1"
                },
                "sectionId": "section-1",
                "columnName": "DistStatus",
                "widgetType": "dropdown",
                "mappedApiField": "activeStatus"
              },
              {
                "id": "ab32336f-aa29-4e29-9829-c2fa8667210f",
                "config": {
                  "label": "DistCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 38,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "DistCode",
                "widgetType": "text-input",
                "mappedApiField": "loginId"
              },
              {
                "id": "4be72aa6-d9a3-4856-b7ee-17d9a38c4a5f",
                "config": {
                  "label": "email",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "columnName": "email",
                "widgetType": "text-input",
                "mappedApiField": "email"
              }
            ]
          },
          {
            "id": "a3515914-ac1e-4c41-9cc9-01c6246df0a0",
            "name": "Parent & Role Info",
            "widgets": [
              {
                "id": "e997a25e-3914-40c0-b521-5d625d4815e9",
                "config": {
                  "label": "DefaultSupplierCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "a3515914-ac1e-4c41-9cc9-01c6246df0a0",
                "columnName": "DefaultSupplierCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.whCode"
              },
              {
                "id": "5def2669-ed1b-4479-822c-e7124f1de0fa",
                "config": {
                  "label": "CompanyCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "a3515914-ac1e-4c41-9cc9-01c6246df0a0",
                "columnName": "CompanyCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.companyCode"
              }
            ]
          },
          {
            "id": "476a3ed6-8823-4f0d-b870-b0f9c215f0eb",
            "name": "Tax and Regulatory Details",
            "widgets": [
              {
                "id": "73e7f56c-7d64-422f-83aa-b2721b19e55b",
                "config": {
                  "label": "StateCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "476a3ed6-8823-4f0d-b870-b0f9c215f0eb",
                "columnName": "StateCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.gstStateCode"
              },
              {
                "id": "2934ee90-2d9f-4dc5-8bf4-30802d0bef01",
                "config": {
                  "label": "PanNumber",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "476a3ed6-8823-4f0d-b870-b0f9c215f0eb",
                "columnName": "PanNumber",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.panNumber"
              },
              {
                "id": "1264c42b-18d6-429b-8393-d840f89362bd",
                "config": {
                  "label": "GstDistTypr",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "476a3ed6-8823-4f0d-b870-b0f9c215f0eb",
                "columnName": "GstDistTypr",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.gstDistributorType"
              },
              {
                "id": "08a8da7f-c0bc-46de-bca4-bf1b0f0dd847",
                "config": {
                  "label": "GstStateCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "476a3ed6-8823-4f0d-b870-b0f9c215f0eb",
                "columnName": "GstStateCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.gstStateCode"
              },
              {
                "id": "d5d705fa-64fe-4229-b2b7-e070a30b7081",
                "config": {
                  "label": "GstTinNumber",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "476a3ed6-8823-4f0d-b870-b0f9c215f0eb",
                "columnName": "GstTinNumber",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.gstTinNumber"
              }
            ]
          },
          {
            "id": "4c719242-e4be-4806-b35a-13d82996a5c6",
            "name": "Primary Address",
            "widgets": [
              {
                "id": "d8223430-8ed9-48d9-bc25-24811516ac26",
                "config": {
                  "label": "CountyCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "4c719242-e4be-4806-b35a-13d82996a5c6",
                "columnName": "CountyCode",
                "widgetType": "text-input",
                "mappedApiField": "countryCode"
              },
              {
                "id": "70c06abd-4210-41da-af3c-07afa47d7915",
                "config": {
                  "label": "CityCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "4c719242-e4be-4806-b35a-13d82996a5c6",
                "columnName": "CityCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.cityCode"
              },
              {
                "id": "47a1fcdb-bc6b-49a4-8a49-7135cd1a6ef9",
                "config": {
                  "label": "Address3",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "4c719242-e4be-4806-b35a-13d82996a5c6",
                "columnName": "Address3",
                "widgetType": "text-input",
                "mappedApiField": "address"
              },
              {
                "id": "4eed45f4-590e-45d7-81e9-1bbb2aab4291",
                "config": {
                  "label": "Address2",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "4c719242-e4be-4806-b35a-13d82996a5c6",
                "columnName": "Address2",
                "widgetType": "text-input",
                "mappedApiField": "address"
              },
              {
                "id": "28d9c2e2-7efd-460e-9d48-066f17a1abde",
                "config": {
                  "label": "Address1",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "4c719242-e4be-4806-b35a-13d82996a5c6",
                "columnName": "Address1",
                "widgetType": "text-input",
                "mappedApiField": "address"
              }
            ]
          },
          {
            "id": "a88c9f68-f1c5-4fdd-bfa2-f5a381e10cde",
            "name": "Others",
            "widgets": [
              {
                "id": "a1df47dc-45c9-4ee6-9f49-ed42d6c32d51",
                "config": {
                  "label": "DistDivision",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "a88c9f68-f1c5-4fdd-bfa2-f5a381e10cde",
                "columnName": "DistDivision",
                "widgetType": "text-input",
                "mappedApiField": "prodauthcode"
              },
              {
                "id": "a8ac829c-c236-47d1-97f5-d9130211f233",
                "config": {
                  "label": "SupplyChainLevelCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "a88c9f68-f1c5-4fdd-bfa2-f5a381e10cde",
                "columnName": "SupplyChainLevelCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.supplyChainLevelCode"
              },
              {
                "id": "03c881dc-d2ff-45a0-9635-4c9a5bebf5ab",
                "config": {
                  "label": "SalesHierValueCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "a88c9f68-f1c5-4fdd-bfa2-f5a381e10cde",
                "columnName": "SalesHierValueCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.SalesHierValueCode"
              },
              {
                "id": "f64ce157-59db-41b3-95d4-529ad956c6fe",
                "config": {
                  "label": "SalesHierLevelCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "a88c9f68-f1c5-4fdd-bfa2-f5a381e10cde",
                "columnName": "SalesHierLevelCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.SalesHierLevelCode"
              },
              {
                "id": "f72ed521-0431-4d87-ae05-0c5df1fe44ec",
                "config": {
                  "label": "GeoHierValueCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "a88c9f68-f1c5-4fdd-bfa2-f5a381e10cde",
                "columnName": "GeoHierValueCode",
                "widgetType": "text-input",
                "mappedApiField": "GeoHierValueCode"
              },
              {
                "id": "fcb5c6a1-1790-45a4-a0ae-373b41b63a9c",
                "config": {
                  "label": "GeoHierLevelCode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 38,
                  "regexValidation": ""
                },
                "sectionId": "a88c9f68-f1c5-4fdd-bfa2-f5a381e10cde",
                "columnName": "GeoHierLevelCode",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.geoHierLevelCode"
              }
            ]
          }
        ],
        "buttonLabel": "distributor"
      },
      {
        "api": "/products",
        "formId": "e4e2b904-7254-4a88-b31f-302de3349362",
        "formName": "price master ",
        "sections": [
          {
            "id": "section-1",
            "name": "Product Identification",
            "widgets": [
              {
                "id": "9f45911d-c22b-400c-813a-bee7270772b2",
                "config": {
                  "label": "skuCode",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 200,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "skuCode",
                "widgetType": "text-input",
                "mappedApiField": "skuCode"
              }
            ]
          },
          {
            "id": "70de7df9-2a2e-49bf-aa45-78dbc63a9370",
            "name": "Pricing Details",
            "widgets": [
              {
                "id": "3b364346-8f1b-4228-98bc-38b76325d43d",
                "config": {
                  "label": "mrp",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "70de7df9-2a2e-49bf-aa45-78dbc63a9370",
                "columnName": "mrp",
                "widgetType": "text-input",
                "mappedApiField": "mrp"
              }
            ]
          },
          {
            "id": "75ac3698-c625-4a6a-b0ed-f171c7c0e99d",
            "name": "Status and Grouping",
            "widgets": [
              {
                "id": "29755830-357c-4bce-b9b3-f9045fdc3957",
                "config": {
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3"
                  ],
                  "label": "activeStatus",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": true,
                  "defaultOption": "Option 1"
                },
                "sectionId": "75ac3698-c625-4a6a-b0ed-f171c7c0e99d",
                "columnName": "activeStatus",
                "widgetType": "dropdown",
                "mappedApiField": "activeStatus"
              }
            ]
          },
          {
            "id": "dbf8ef23-0128-4667-a382-0deb83fe4c3b",
            "name": "Additional Fields",
            "widgets": [
              {
                "id": "41e5e7f3-34bb-466e-8940-853adadf771c",
                "config": {
                  "label": "BatchId",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "BatchId",
                "widgetType": "text-input",
                "mappedApiField": "BatchId"
              },
              {
                "id": "add86875-32b4-4152-9b0e-bbfbea0165d7",
                "config": {
                  "label": "casePtr",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "casePtr",
                "widgetType": "text-input",
                "mappedApiField": "casePtr"
              },
              {
                "id": "e914275a-0485-4fad-867c-300ba914bb62",
                "config": {
                  "label": "packPtr",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "packPtr",
                "widgetType": "text-input",
                "mappedApiField": "packPtr"
              },
              {
                "id": "d08edf4e-204b-471b-8899-b73f2a7df3b5",
                "config": {
                  "label": "otherUnitPtr",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "otherUnitPtr",
                "widgetType": "text-input",
                "mappedApiField": "otherUnitPtr"
              },
              {
                "id": "bc2757cd-2980-4c07-bf32-d89245520d75",
                "config": {
                  "label": "loginId",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "loginId",
                "widgetType": "text-input",
                "mappedApiField": "loginId"
              },
              {
                "id": "a66f3038-e1bc-4f6b-9ecb-60771b865802",
                "config": {
                  "label": "channel",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "channel",
                "widgetType": "text-input",
                "mappedApiField": "channel"
              },
              {
                "id": "f6bf7dd4-8987-4838-b105-6422c625d56b",
                "config": {
                  "hint": "",
                  "label": "fromDate",
                  "editable": true,
                  "required": true,
                  "defaultDate": ""
                },
                "columnName": "fromDate",
                "widgetType": "date-picker",
                "mappedApiField": "fromDate"
              },
              {
                "id": "5fe45828-2ccc-430a-a9dd-067eef9f5135",
                "config": {
                  "label": "extendedattributes1",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "extendedattributes1",
                "widgetType": "text-input",
                "mappedApiField": "extendedattributes1"
              },
              {
                "id": "930d04e0-3f3d-43c2-acc4-69c91a008e61",
                "config": {
                  "label": "extendedattributes2",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "extendedattributes2",
                "widgetType": "text-input",
                "mappedApiField": "extendedattributes2"
              },
              {
                "id": "21ea3605-49a9-4b45-b058-add6c1fe43a6",
                "config": {
                  "label": "extendedattributes3",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "extendedattributes3",
                "widgetType": "text-input",
                "mappedApiField": "extendedattributes3"
              },
              {
                "id": "87182e1f-5132-496f-92d0-3a6bc2d0720c",
                "config": {
                  "label": "extendedattributes4",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "extendedattributes4",
                "widgetType": "text-input",
                "mappedApiField": "extendedattributes4"
              },
              {
                "id": "ce4ab126-6aa1-4e89-bc72-b8a6e2200079",
                "config": {
                  "label": "extendedattributes5",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "extendedattributes5",
                "widgetType": "text-input",
                "mappedApiField": "extendedattributes5"
              }
            ]
          }
        ],
        "buttonLabel": "price"
      },
      {
        "api": "/outletDetails",
        "formId": "1d559bf2-e72d-4427-ab03-6d36e07c9158",
        "formName": "outlet master",
        "sections": [
          {
            "id": "section-1",
            "name": "Outlet Identification",
            "widgets": [
              {
                "id": "34b3afd5-04b5-4626-9667-b7e8ea93b552",
                "config": {
                  "label": "account",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "account",
                "widgetType": "text-input",
                "mappedApiField": "account"
              },
              {
                "id": "64aaec06-a472-47fa-87e0-129eae1c9394",
                "config": {
                  "label": "marketid",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 12,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "marketid",
                "widgetType": "text-input",
                "mappedApiField": "marketId"
              },
              {
                "id": "e510e149-d84c-48d6-b412-5f4c571662d7",
                "config": {
                  "label": "marketname",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "marketname",
                "widgetType": "text-input",
                "mappedApiField": "marketName"
              },
              {
                "id": "7b56443d-9be4-4822-bb9a-05d50e46e723",
                "config": {
                  "label": "tinno",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 15,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "tinno",
                "widgetType": "text-input",
                "mappedApiField": "tinNo"
              },
              {
                "id": "53a6ec3a-d813-4af5-869c-7c4252b6d80b",
                "config": {
                  "label": "outletcode",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 45,
                  "regexValidation": ""
                },
                "columnName": "outletcode",
                "widgetType": "text-input",
                "mappedApiField": "outletCode"
              },
              {
                "id": "cf637735-763c-4b9d-8588-62afc61a733d",
                "config": {
                  "label": "outletname",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "columnName": "outletname",
                "widgetType": "text-input",
                "mappedApiField": "outletName"
              }
            ]
          },
          {
            "id": "2533bfbd-6771-4b51-9606-ec4c33747608",
            "name": "Outlet Attributes",
            "widgets": [
              {
                "id": "b125b54c-d835-4b60-9f32-21aa552bc27f",
                "config": {
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3"
                  ],
                  "label": "channel",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": true,
                  "defaultOption": "Option 1"
                },
                "sectionId": "2533bfbd-6771-4b51-9606-ec4c33747608",
                "columnName": "channel",
                "widgetType": "dropdown",
                "mappedApiField": "channel"
              },
              {
                "id": "b295df62-9a2a-457b-ad3e-ed2af4ef0fcd",
                "config": {
                  "label": "outletcategory",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 100,
                  "regexValidation": ""
                },
                "sectionId": "2533bfbd-6771-4b51-9606-ec4c33747608",
                "columnName": "outletcategory",
                "widgetType": "text-input",
                "mappedApiField": "outletCategory"
              },
              {
                "id": "adc5dbaa-4312-43e1-9621-7a94ea99ca23",
                "config": {
                  "label": "Outlet's Channel Code",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "Outlet's Channel Code",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.OutletChannelCode"
              },
              {
                "id": "2182541d-a54c-4b55-b948-c1657f1da890",
                "config": {
                  "label": "outletClass",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "columnName": "outletClass",
                "widgetType": "text-input",
                "mappedApiField": "outletClass"
              },
              {
                "id": "97a149f7-d0ee-4ae1-855b-afe4ba42cf92",
                "config": {
                  "label": "outlettype",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "columnName": "outlettype",
                "widgetType": "text-input",
                "mappedApiField": "outletType"
              },
              {
                "id": "788d728d-40a7-48d6-afcf-6911faab1ff6",
                "config": {
                  "label": "subchannel",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "columnName": "subchannel",
                "widgetType": "text-input",
                "mappedApiField": "subChannel"
              },
              {
                "id": "a905df69-ff15-490c-8ce9-039187927b1e",
                "config": {
                  "label": "distributionchannel",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 15,
                  "regexValidation": ""
                },
                "columnName": "distributionchannel",
                "widgetType": "text-input",
                "mappedApiField": "distributionChannel"
              },
              {
                "id": "3dbe6d9e-d082-4f72-9710-42cc3db6f1b3",
                "config": {
                  "label": "outletdivision",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "columnName": "outletdivision",
                "widgetType": "text-input",
                "mappedApiField": "outletDivision"
              }
            ]
          },
          {
            "id": "318f93e9-0ef3-4904-bbb5-eaab6d0eb904",
            "name": "Tax and Compliance",
            "widgets": [
              {
                "id": "05dbb9dd-e82d-479b-ad7e-663e2a0d19b9",
                "config": {
                  "label": "Outlet PAN",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "318f93e9-0ef3-4904-bbb5-eaab6d0eb904",
                "columnName": "Outlet PAN",
                "widgetType": "text-input",
                "mappedApiField": "AccountInfo.pan"
              },
              {
                "id": "08e2ac57-2269-4680-bfba-6a6f0204d208",
                "config": {
                  "label": "gstno",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 15,
                  "regexValidation": ""
                },
                "sectionId": "318f93e9-0ef3-4904-bbb5-eaab6d0eb904",
                "columnName": "gstno",
                "widgetType": "text-input",
                "mappedApiField": "gstno"
              },
              {
                "id": "cd66737c-eca8-497e-badf-215991739305",
                "config": {
                  "label": "TCS eligibility",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "318f93e9-0ef3-4904-bbb5-eaab6d0eb904",
                "columnName": "TCS eligibility",
                "widgetType": "text-input",
                "mappedApiField": "tcsEligibility"
              }
            ]
          },
          {
            "id": "f1824c9d-4491-4f61-99a8-9806e65f2e17",
            "name": "Contact Details",
            "widgets": [
              {
                "id": "b5ae37f3-99ea-4ff5-affc-bf0a9d2eb6f2",
                "config": {
                  "label": "contactno",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "f1824c9d-4491-4f61-99a8-9806e65f2e17",
                "columnName": "contactno",
                "widgetType": "text-input",
                "mappedApiField": "contactno"
              },
              {
                "id": "278cef2e-8432-48ec-ab90-4c072308768d",
                "config": {
                  "label": "Outlet email ID",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "f1824c9d-4491-4f61-99a8-9806e65f2e17",
                "columnName": "Outlet email ID",
                "widgetType": "text-input",
                "mappedApiField": "email"
              }
            ]
          },
          {
            "id": "b4b4235e-6036-426b-88b8-e21fc97ae17d",
            "name": "Financial Details",
            "widgets": [
              {
                "id": "4e7c6f12-a8d3-49d9-ab98-ac4ec1fbd152",
                "config": {
                  "label": "Outlet Credit Limit",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "b4b4235e-6036-426b-88b8-e21fc97ae17d",
                "columnName": "Outlet Credit Limit",
                "widgetType": "text-input",
                "mappedApiField": "CreditStatus.creditLimit"
              },
              {
                "id": "4d7f5b1b-9200-45a2-b57d-bf0f8be774bf",
                "config": {
                  "label": "Outlet Outstanding Balance",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "b4b4235e-6036-426b-88b8-e21fc97ae17d",
                "columnName": "Outlet Outstanding Balance",
                "widgetType": "text-input",
                "mappedApiField": "CreditStatus.creditLimit - CreditStatus.creditAvailable"
              },
              {
                "id": "bd3b7d65-739f-4854-bdc0-d6b1fba93660",
                "config": {
                  "label": "Credit days",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 4,
                  "regexValidation": ""
                },
                "sectionId": "b4b4235e-6036-426b-88b8-e21fc97ae17d",
                "columnName": "Credit days",
                "widgetType": "text-input",
                "mappedApiField": "CreditStatus.totalDueDays"
              },
              {
                "id": "07fd4df2-8da1-4d59-a7f5-955b007316dd",
                "config": {
                  "list": [
                    "Cash",
                    "Credit"
                  ],
                  "label": "Outlet Payment mode",
                  "value": "",
                  "hintText": "Select an option",
                  "required": false,
                  "defaultOption": ""
                },
                "sectionId": "b4b4235e-6036-426b-88b8-e21fc97ae17d",
                "columnName": "Outlet Payment mode",
                "widgetType": "dropdown",
                "mappedApiField": "paymentMode"
              },
              {
                "id": "2642f7d7-d14d-40a7-aded-685a99f44a86",
                "config": {
                  "label": "Outlet Bank",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "b4b4235e-6036-426b-88b8-e21fc97ae17d",
                "columnName": "Outlet Bank",
                "widgetType": "text-input",
                "mappedApiField": "AccountInfo.bankName"
              },
              {
                "id": "a8efd13d-55db-4670-9061-594e9d975184",
                "config": {
                  "label": "Outlet IFSC Code",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 12,
                  "regexValidation": ""
                },
                "sectionId": "b4b4235e-6036-426b-88b8-e21fc97ae17d",
                "columnName": "Outlet IFSC Code",
                "widgetType": "text-input",
                "mappedApiField": "AccountInfo.ifsc"
              },
              {
                "id": "975dfd4c-a383-4d9c-8bf0-d336e1c3315b",
                "config": {
                  "label": "Outlet Account Number",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 15,
                  "regexValidation": ""
                },
                "sectionId": "b4b4235e-6036-426b-88b8-e21fc97ae17d",
                "columnName": "Outlet Account Number",
                "widgetType": "text-input",
                "mappedApiField": "AccountInfo.accountNumber"
              }
            ]
          },
          {
            "id": "3bf2282d-b4d9-4231-a324-86b0e3f09aee",
            "name": "Sales and Pricing",
            "widgets": [
              {
                "id": "fc8f7df5-3853-4ea7-a2b1-280d564ce018",
                "config": {
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3"
                  ],
                  "label": "priceListId",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": true,
                  "defaultOption": "Option 1"
                },
                "sectionId": "3bf2282d-b4d9-4231-a324-86b0e3f09aee",
                "columnName": "priceListId",
                "widgetType": "dropdown",
                "mappedApiField": "priceListId"
              },
              {
                "id": "2f5cde35-2e96-49d7-a758-283ba6838e7d",
                "config": {
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3"
                  ],
                  "label": "Sales Mode",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": false,
                  "defaultOption": "Option 1"
                },
                "sectionId": "3bf2282d-b4d9-4231-a324-86b0e3f09aee",
                "columnName": "Sales Mode",
                "widgetType": "dropdown",
                "mappedApiField": "extendedAttributes.SalesMode"
              },
              {
                "id": "e3548678-3850-4bb4-b655-ba89710f9770",
                "config": {
                  "label": "beat",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "3bf2282d-b4d9-4231-a324-86b0e3f09aee",
                "columnName": "beat",
                "widgetType": "text-input",
                "mappedApiField": "beat"
              }
            ]
          },
          {
            "id": "f47bffbc-0058-4d9a-a9b2-35a7a3407ac6",
            "name": "Status",
            "widgets": [
              {
                "id": "68e287f1-a9d3-4bd6-94c4-d8d544db4471",
                "config": {
                  "label": "active",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "f47bffbc-0058-4d9a-a9b2-35a7a3407ac6",
                "columnName": "active",
                "widgetType": "text-input",
                "mappedApiField": "activeStatus"
              }
            ]
          },
          {
            "id": "5e285877-177c-496f-b7f5-655dbe93ec55",
            "name": "Parent Mapping",
            "widgets": [
              {
                "id": "edac5143-d7c3-4d22-ab3e-7c15aad3b747",
                "config": {
                  "label": "parent-0-1-id",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "5e285877-177c-496f-b7f5-655dbe93ec55",
                "columnName": "parent-0-1-id",
                "widgetType": "text-input",
                "mappedApiField": "extendedAttributes.parent-0-1-id"
              }
            ]
          },
          {
            "id": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
            "name": "Outlet Location",
            "widgets": [
              {
                "id": "aa919f0e-5d91-4ca7-9944-813aa20c0b31",
                "config": {
                  "label": "pincode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 6,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "pincode",
                "widgetType": "text-input",
                "mappedApiField": "Location.pincode"
              },
              {
                "id": "bae88316-2fd5-42c4-9186-300f3b45f6d4",
                "config": {
                  "label": "city",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "city",
                "widgetType": "text-input",
                "mappedApiField": "Location.city"
              },
              {
                "id": "ca3b7928-6f2b-478e-9a54-6bdefc6a0ff1",
                "config": {
                  "label": "state",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "state",
                "widgetType": "text-input",
                "mappedApiField": "Location.state"
              },
              {
                "id": "443e5fde-d8e9-4a23-a0ef-c6b50c73e01d",
                "config": {
                  "label": "country",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "country",
                "widgetType": "text-input",
                "mappedApiField": "Location.country"
              },
              {
                "id": "29af11d5-7e8d-4655-9c46-ebe6f56b2c2e",
                "config": {
                  "label": "region",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "region",
                "widgetType": "text-input",
                "mappedApiField": "Location.region"
              },
              {
                "id": "061a7128-f779-4278-acb9-a3b4970ede93",
                "config": {
                  "label": "zone",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "zone",
                "widgetType": "text-input",
                "mappedApiField": "Location.zone"
              },
              {
                "id": "0d2adb70-7f91-4b62-9e30-f71087fd6518",
                "config": {
                  "label": "area",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 15,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "area",
                "widgetType": "text-input",
                "mappedApiField": "Location.area"
              },
              {
                "id": "2b44172a-b8cc-4498-9345-c8ac255f0abf",
                "config": {
                  "label": "town",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 15,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "town",
                "widgetType": "text-input",
                "mappedApiField": "Location.town"
              },
              {
                "id": "842637a7-0a30-49d7-ac67-1b465531a5a2",
                "config": {
                  "label": "branch",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "branch",
                "widgetType": "text-input",
                "mappedApiField": "Location.branch"
              },
              {
                "id": "8f35658c-0d18-42fc-93bc-7d3a8b045d79",
                "config": {
                  "label": "latitude",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "latitude",
                "widgetType": "text-input",
                "mappedApiField": "latitude"
              },
              {
                "id": "81c9ffcd-22d8-478a-8df4-c10d409a836e",
                "config": {
                  "label": "longitude",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "f5830cc7-2992-4beb-9b99-0bfdedcd1ae6",
                "columnName": "longitude",
                "widgetType": "text-input",
                "mappedApiField": "longitude"
              }
            ]
          },
          {
            "id": "76fcb629-57d1-4995-b12c-e571724502b6",
            "name": "Extra Fields",
            "widgets": [
              {
                "id": "cc31c96e-b2f0-468b-b2b0-7cc6c8a87551",
                "config": {
                  "label": "companycode",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "companycode",
                "widgetType": "text-input",
                "mappedApiField": "outletAttr5"
              },
              {
                "id": "3dab2406-25ec-49c9-a91d-4d7f36264304",
                "config": {
                  "label": "distroutletcode",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "distroutletcode",
                "widgetType": "text-input",
                "mappedApiField": "outletAttr6"
              },
              {
                "id": "9af05f9a-5a20-4519-a7fe-7e24df3c2c1f",
                "config": {
                  "label": "beatName",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "beatName",
                "widgetType": "text-input",
                "mappedApiField": "beatName"
              },
              {
                "id": "68af3d5f-e8f1-48e0-bacd-4e9b09aa3dd7",
                "config": {
                  "label": "dateofopening",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "columnName": "dateofopening",
                "widgetType": "text-input",
                "mappedApiField": "doo"
              },
              {
                "id": "2a7a91c2-804e-4e1b-90e2-ccef724ed5c6",
                "config": {
                  "label": "dateofclosing",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "dateofclosing",
                "widgetType": "text-input",
                "mappedApiField": "dateofclosing"
              },
              {
                "id": "13850768-e110-4701-8b14-bfdaaacf2cbd",
                "config": {
                  "label": "address 1",
                  "value": "",
                  "editable": true,
                  "hintText": "text",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "columnName": "address 1",
                "widgetType": "text-input",
                "mappedApiField": "address"
              },
              {
                "id": "a15c3613-b373-4ea8-8add-a108eb736f6c",
                "config": {
                  "label": "address 2",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "address 2",
                "widgetType": "text-input",
                "mappedApiField": "address5"
              },
              {
                "id": "a38adc87-f5af-4100-83f7-7a2ae01288f8",
                "config": {
                  "label": "district",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "district",
                "widgetType": "text-input",
                "mappedApiField": "Location.district"
              },
              {
                "id": "f2663cb2-29ff-4edc-84b4-05937846aa90",
                "config": {
                  "label": "territory",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "territory",
                "widgetType": "text-input",
                "mappedApiField": "Location.territory"
              },
              {
                "id": "ba8a2886-2338-45a4-9b15-3eb5e1d7b453",
                "config": {
                  "label": "Outlet FSSAI Number",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "Outlet FSSAI Number",
                "widgetType": "text-input",
                "mappedApiField": "fssaiNumber"
              },
              {
                "id": "40b07471-669b-4235-98cf-8432c0d998ec",
                "config": {
                  "label": "prodauthcode",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "prodauthcode",
                "widgetType": "text-input",
                "mappedApiField": "prodauthcode"
              }
            ]
          }
        ],
        "buttonLabel": "outlet "
      },
      {
        "api": "/users",
        "formId": "46c09371-996a-498a-ae66-0e364d58b23d",
        "formName": "user form ",
        "sections": [
          {
            "id": "section-1",
            "name": "Untitled Section 1",
            "widgets": [
              {
                "id": "f2a8e10b-3f0c-4f7b-8e24-bf552b4f7577",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "TEXT BOX",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "widgetType": "text-input",
                "mappedApiField": "activeStatusReason"
              },
              {
                "id": "9ccabf19-d40f-460e-8511-f1c5d3149be9",
                "icon": "✅",
                "name": "Checkbox",
                "config": {
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3"
                  ],
                  "label": "Check this box",
                  "checked": [],
                  "required": false
                },
                "sectionId": "section-1",
                "widgetType": "checkbox",
                "mappedApiField": "source"
              }
            ]
          }
        ],
        "buttonLabel": "user "
      },
      {
        "api": "/outletDetails",
        "formId": "846fdbe9-0f40-4287-849b-08b03f78fc8a",
        "formName": "Delivery Route Master",
        "sections": [
          {
            "id": "7f39b57f-ba27-4fb1-a55c-ab68775e5c6c",
            "name": "Route and Coverage",
            "widgets": [
              {
                "id": "f0f54d2a-e039-456c-aee4-4229cd7c95e7",
                "config": {
                  "label": "Delivery Route No",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "Delivery Route No",
                "widgetType": "text-input",
                "mappedApiField": "Delivery Route No"
              },
              {
                "id": "46ee5b50-47b6-49b7-8476-6cd0f1f6fba4",
                "config": {
                  "label": "Sales route",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "Sales route",
                "widgetType": "text-input",
                "mappedApiField": "Sales route"
              }
            ]
          },
          {
            "id": "25bf6d6e-2418-4b34-a0f4-ed832d076a2d",
            "name": "\t Outlet and Distributor Information",
            "widgets": [
              {
                "id": "afbd6723-d35b-4052-858b-ee4c93d53d73",
                "config": {
                  "label": "Outlet Code",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "25bf6d6e-2418-4b34-a0f4-ed832d076a2d",
                "columnName": "Outlet Code",
                "widgetType": "text-input",
                "mappedApiField": "Outlet Code"
              },
              {
                "id": "b75e8768-50b4-4d63-a45f-c791029054b2",
                "config": {
                  "label": "Distributor Code",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "25bf6d6e-2418-4b34-a0f4-ed832d076a2d",
                "columnName": "Distributor Code",
                "widgetType": "text-input",
                "mappedApiField": "Distributor Code"
              }
            ]
          },
          {
            "id": "9aa1d597-6eb3-44c2-9910-c38abfdd4e6a",
            "name": "Sales Personnel Details",
            "widgets": [
              {
                "id": "1ddc6f3f-64db-4ef8-9224-65202938c711",
                "config": {
                  "label": "Salesman code",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "9aa1d597-6eb3-44c2-9910-c38abfdd4e6a",
                "columnName": "Salesman code",
                "widgetType": "text-input",
                "mappedApiField": "Salesman code"
              },
              {
                "id": "1ef2944e-46fb-42e8-8776-4faa715ae314",
                "config": {
                  "label": "Salesrep",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "9aa1d597-6eb3-44c2-9910-c38abfdd4e6a",
                "columnName": "Salesrep",
                "widgetType": "text-input",
                "mappedApiField": "Salesrep"
              },
              {
                "id": "734f0034-ce9b-414f-a927-8ded4e0994d9",
                "config": {
                  "label": "Salesrep code",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "9aa1d597-6eb3-44c2-9910-c38abfdd4e6a",
                "columnName": "Salesrep code",
                "widgetType": "text-input",
                "mappedApiField": "Salesrep code"
              }
            ]
          },
          {
            "id": "e362c8c6-9edc-4aa4-abc4-310dbcc547c0",
            "name": "Sales Details",
            "widgets": [
              {
                "id": "acb3af1b-86fa-4804-abba-70762ee36d85",
                "config": {
                  "label": "Sales Mode",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "e362c8c6-9edc-4aa4-abc4-310dbcc547c0",
                "columnName": "Sales Mode",
                "widgetType": "text-input",
                "mappedApiField": "Sales Mode"
              },
              {
                "id": "fcc78730-e684-43dc-85ef-cc034444a6e4",
                "config": {
                  "label": "prod auth",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "sectionId": "e362c8c6-9edc-4aa4-abc4-310dbcc547c0",
                "columnName": "prod auth",
                "widgetType": "text-input",
                "mappedApiField": "prod auth"
              }
            ]
          }
        ],
        "buttonLabel": "Delivery Master"
      },
      {
        "api": "/products",
        "formId": "473d7f5f-8080-42cf-9b15-36f981e68cb5",
        "formName": "Outlet Distributor Mapping",
        "sections": [
          {
            "id": "104540fe-9e81-4734-8337-e270a092ba46",
            "name": "Untitled Section 1",
            "widgets": [
              {
                "id": "6002bda7-dce2-4905-8a25-b316428bc455",
                "config": {
                  "label": "uid",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "UID",
                "widgetType": "text-input",
                "mappedApiField": "UID"
              },
              {
                "id": "3e137771-9e89-46fb-a9d7-8fb90c1b08e5",
                "config": {
                  "label": "mobilenumber",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "MobileNumber",
                "widgetType": "text-input",
                "mappedApiField": "MobileNumber"
              },
              {
                "id": "61577cf4-8896-45ed-9716-d2584be1ea57",
                "config": {
                  "label": "a",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "a",
                "widgetType": "text-input",
                "mappedApiField": "a"
              },
              {
                "id": "349b6b7e-f297-484e-98e3-954bfc0e7aa5",
                "config": {
                  "label": "b",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "b",
                "widgetType": "text-input",
                "mappedApiField": "b"
              },
              {
                "id": "57be2dbb-5e65-4b0a-bb2a-9e23fc55f745",
                "config": {
                  "label": "c",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "c",
                "widgetType": "text-input",
                "mappedApiField": "c"
              },
              {
                "id": "d8391ce2-13e6-4dce-9642-264b8d686592",
                "config": {
                  "label": "d",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "D",
                "widgetType": "text-input",
                "mappedApiField": "D"
              },
              {
                "id": "b24f2199-089b-4e2c-8ae1-e70b88ddfe8e",
                "config": {
                  "label": "e",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "E",
                "widgetType": "text-input",
                "mappedApiField": "E"
              },
              {
                "id": "5d8b964a-36a7-459b-ba3a-4013916d0257",
                "config": {
                  "label": "f",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "f",
                "widgetType": "text-input",
                "mappedApiField": "f"
              },
              {
                "id": "46b22662-d97a-4be6-8c7e-beec07031931",
                "config": {
                  "label": "g",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "g",
                "widgetType": "text-input",
                "mappedApiField": "g"
              },
              {
                "id": "2d4bbd65-8200-485b-bc6a-91faa30c6208",
                "config": {
                  "label": "h",
                  "value": "",
                  "editable": true,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": "",
                  "regexValidation": ""
                },
                "columnName": "H",
                "widgetType": "text-input",
                "mappedApiField": "H"
              }
            ]
          }
        ],
        "buttonLabel": "test"
      },
      {
        "api": "/userActivity",
        "formId": "9445b7fd-83b1-4aae-a60a-1a50fd6fca44",
        "formName": "Vehicle Master",
        "sections": [
          {
            "id": "section-1",
            "name": "Vehicle Identification",
            "widgets": [
              {
                "id": "a065f38b-df3b-4541-9c31-bdbb785db57c",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Vehicle ID (Key)",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 200,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "Vehicle ID (Key)",
                "widgetType": "text-input",
                "mappedApiField": "Vehicle ID (Key)"
              },
              {
                "id": "515427f1-0040-4d67-af4b-82629390dd6d",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Registration Number",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "Registration Number",
                "widgetType": "text-input",
                "mappedApiField": "Registration Number"
              },
              {
                "id": "19c74369-2672-42c7-968f-5d5952e99aca",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Insurance ID",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "Insurance ID",
                "widgetType": "text-input",
                "mappedApiField": "Insurance ID",
                "extendedMappedApiFieldName": ""
              }
            ]
          },
          {
            "id": "2b853306-409b-44eb-80f1-d5aef9fa849c",
            "name": "Vehicle Specifications",
            "widgets": [
              {
                "id": "c45785d7-9476-4182-9ae6-ac4a338e80f1",
                "config": {
                  "list": [
                    "TATA ACE",
                    "PICKUP",
                    "TRUCK (14 ft)",
                    "TRUCK (17 ft)"
                  ],
                  "label": "Vehicle Type",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": true,
                  "defaultOption": "Option 1"
                },
                "sectionId": "2b853306-409b-44eb-80f1-d5aef9fa849c",
                "columnName": "Vehicle Type",
                "widgetType": "dropdown",
                "mappedApiField": "Vehicle Type"
              },
              {
                "id": "cf2dad56-73ae-4d3d-b3b9-1f366fb38e3d",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Vehicle Length (FT)",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 14,
                  "regexValidation": ""
                },
                "sectionId": "2b853306-409b-44eb-80f1-d5aef9fa849c",
                "columnName": "Vehicle Length (FT)",
                "widgetType": "text-input",
                "mappedApiField": "Vehicle Length (FT)"
              },
              {
                "id": "d8312784-3f59-4018-b873-9fe89a920b74",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Vehicle Width (FT)",
                  "value": "-18",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 6,
                  "regexValidation": ""
                },
                "sectionId": "2b853306-409b-44eb-80f1-d5aef9fa849c",
                "columnName": "Vehicle Width (FT)",
                "widgetType": "text-input",
                "mappedApiField": "Vehicle Width (FT)"
              },
              {
                "id": "ae163334-3927-4382-a5f7-3a19415a7b88",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Vehicle Height (FT)",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 7,
                  "regexValidation": ""
                },
                "sectionId": "2b853306-409b-44eb-80f1-d5aef9fa849c",
                "columnName": "Vehicle Height (FT)",
                "widgetType": "text-input",
                "mappedApiField": "Vehicle Height (FT)"
              },
              {
                "id": "10f1097d-cab3-4b16-a9c5-0cb2a7afc2ab",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Vehicle Load Capacity (KG)",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "2b853306-409b-44eb-80f1-d5aef9fa849c",
                "columnName": "Vehicle Load Capacity (KG)",
                "widgetType": "text-input",
                "mappedApiField": "Vehicle Load Capacity (KG)"
              },
              {
                "id": "e1521e35-68ce-46f4-b0f5-878c6a314cac",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Vehicle Capacity (CU.FT)",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "2b853306-409b-44eb-80f1-d5aef9fa849c",
                "columnName": "Vehicle Capacity (CU.FT)",
                "widgetType": "text-input",
                "mappedApiField": "Vehicle Capacity (CU.FT)"
              },
              {
                "id": "fc8be74e-5150-404a-be7b-29506457a636",
                "config": {
                  "list": [
                    "DIESEL",
                    "PETROL",
                    "CNG",
                    "ELECTRIC"
                  ],
                  "label": "Fuel Type",
                  "value": "",
                  "hintText": "Select an option",
                  "required": false,
                  "defaultOption": "Option 1"
                },
                "sectionId": "2b853306-409b-44eb-80f1-d5aef9fa849c",
                "columnName": "Fuel Type",
                "widgetType": "dropdown",
                "mappedApiField": "Fuel Type"
              }
            ]
          },
          {
            "id": "d7235d1c-d5ae-4a78-9f8c-cf6194e288a2",
            "name": "Compliance and Validity",
            "widgets": [
              {
                "id": "d27f5900-dfe3-4e05-bceb-e870ae3a938a",
                "icon": "📅",
                "name": "Date Picker",
                "config": {
                  "hint": "",
                  "label": "Purchase Date",
                  "editable": true,
                  "required": true,
                  "defaultDate": ""
                },
                "sectionId": "d7235d1c-d5ae-4a78-9f8c-cf6194e288a2",
                "columnName": "Purchase Date",
                "widgetType": "date-picker",
                "mappedApiField": "Purchase Date"
              },
              {
                "id": "13dc977f-7b64-450f-ad20-e5b9020329f8",
                "icon": "📅",
                "name": "Date Picker",
                "config": {
                  "hint": "",
                  "label": "Insurance Validity Date",
                  "editable": true,
                  "required": true,
                  "defaultDate": ""
                },
                "sectionId": "d7235d1c-d5ae-4a78-9f8c-cf6194e288a2",
                "columnName": "Insurance Validity Date",
                "widgetType": "date-picker",
                "mappedApiField": "Insurance Validity Date"
              }
            ]
          },
          {
            "id": "9401f64e-b52f-4234-ba78-77ea0a865381",
            "name": "Tracking and Status",
            "widgets": [
              {
                "id": "5e7077e4-4137-4411-b411-a97f8584659b",
                "config": {
                  "list": [
                    "ACTIVE",
                    "UNDER_MAINTENANCE",
                    "IN_USE",
                    "AVAILABLE",
                    "INACTIVE"
                  ],
                  "label": "Current Status",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": true,
                  "defaultOption": "Option 1"
                },
                "sectionId": "9401f64e-b52f-4234-ba78-77ea0a865381",
                "columnName": "Current Status",
                "widgetType": "dropdown",
                "mappedApiField": "Current Status"
              },
              {
                "id": "3c30809b-4811-425b-8413-5cf4ffabaf15",
                "config": {
                  "list": [
                    "Y",
                    "N"
                  ],
                  "label": "GPS Tracking",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": true,
                  "defaultOption": "Option 1"
                },
                "sectionId": "9401f64e-b52f-4234-ba78-77ea0a865381",
                "columnName": "GPS Tracking",
                "widgetType": "dropdown",
                "mappedApiField": "GPS Tracking"
              }
            ]
          },
          {
            "id": "4883eb09-63fd-4ddb-93b1-5631de30b8da",
            "name": "Additional Fields",
            "widgets": [
              {
                "id": "b2caf940-c30e-431b-9b5c-4f7440fa369d",
                "config": {
                  "label": "Distributor Id",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 40,
                  "regexValidation": ""
                },
                "columnName": "Distributor Id",
                "widgetType": "text-input",
                "mappedApiField": "Distributor Id"
              }
            ]
          }
        ],
        "buttonLabel": "Vehicle"
      },
      {
        "api": "/outletDetails",
        "formId": "18c45c27-30fc-4572-94fd-b823b3607f8d",
        "formName": "Staff Master",
        "sections": [
          {
            "id": "section-1",
            "name": "Staff Identification Details",
            "widgets": [
              {
                "id": "87ca4c8c-2a0d-4408-b9ba-c2fd87dda815",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Staff Code (Key)",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": true,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 200,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "Staff Code (Key)",
                "widgetType": "text-input",
                "mappedApiField": "key1"
              },
              {
                "id": "c4b8cf21-34ee-48dc-a42a-be2d735d0db3",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Staff Name",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 200,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "Staff Name",
                "widgetType": "text-input",
                "mappedApiField": "name"
              }
            ]
          },
          {
            "id": "5a44740c-b429-4895-b630-8ac8da521fa8",
            "name": "Job Details",
            "widgets": [
              {
                "id": "db8e8488-4158-4901-a255-21721993f90f",
                "icon": "📅",
                "name": "Date Picker",
                "config": {
                  "hint": "",
                  "label": "Date Of Joining",
                  "editable": true,
                  "required": false,
                  "defaultDate": ""
                },
                "sectionId": "5a44740c-b429-4895-b630-8ac8da521fa8",
                "columnName": "Date Of Joining",
                "widgetType": "date-picker",
                "mappedApiField": "Date Of Joining"
              },
              {
                "id": "047c6697-4312-4aa8-a167-4be12cd855df",
                "icon": "✅",
                "name": "Checkbox",
                "config": {
                  "label": "Staff Designation",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 200,
                  "regexValidation": ""
                },
                "sectionId": "5a44740c-b429-4895-b630-8ac8da521fa8",
                "columnName": "Staff Designation",
                "widgetType": "text-input",
                "mappedApiField": "key2"
              }
            ]
          },
          {
            "id": "dcbb12f2-f1d2-4474-a6ce-47d5fb105477",
            "name": "Contact Information",
            "widgets": [
              {
                "id": "9dffb41c-894e-4669-b011-29c809d17049",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Staff Email",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 100,
                  "regexValidation": ""
                },
                "sectionId": "dcbb12f2-f1d2-4474-a6ce-47d5fb105477",
                "columnName": "Staff Email",
                "widgetType": "text-input",
                "mappedApiField": "email"
              },
              {
                "id": "fff29815-89a3-4083-b509-1f5b56241580",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Staff Contact No",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "number"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 10,
                  "regexValidation": ""
                },
                "sectionId": "dcbb12f2-f1d2-4474-a6ce-47d5fb105477",
                "columnName": "Staff Contact No",
                "widgetType": "text-input",
                "mappedApiField": "key3"
              }
            ]
          },
          {
            "id": "8735f9fd-fcb2-4f9b-add5-f2d72881550f",
            "name": "Asset Details",
            "widgets": [
              {
                "id": "ff517f99-c332-4780-afe2-a10e8cec0ee5",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Staff Asset Id",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "8735f9fd-fcb2-4f9b-add5-f2d72881550f",
                "columnName": "Staff Asset Id",
                "widgetType": "text-input",
                "mappedApiField": "key5"
              },
              {
                "id": "314cc4e5-f943-467c-8602-ea210465416b",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Staff Asset",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": true,
                  "maxCharacters": 100,
                  "regexValidation": ""
                },
                "sectionId": "8735f9fd-fcb2-4f9b-add5-f2d72881550f",
                "columnName": "Staff Asset",
                "widgetType": "text-input",
                "mappedApiField": "key4"
              }
            ]
          },
          {
            "id": "077ae0de-bb67-46cf-a6b7-2c8aa8621706",
            "name": "Other ",
            "widgets": []
          }
        ],
        "buttonLabel": "Staff"
      },
      {
        "api": "/productActivity",
        "formId": "abed71ba-3dae-451c-bb64-e30a04022594",
        "formName": "PJP Master",
        "sections": [
          {
            "id": "section-1",
            "name": "Outlet and Distributor Info",
            "widgets": [
              {
                "id": "6409958e-4b75-476b-93a8-d7904120f558",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Outlet Name",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "Outlet Name",
                "widgetType": "text-input",
                "mappedApiField": "outletName"
              },
              {
                "id": "67bb8c28-f00e-4b81-9b18-3b75ba49485a",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "OutletCode",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "OutletCode",
                "widgetType": "text-input",
                "mappedApiField": "outletcode"
              },
              {
                "id": "2aca8662-15a3-48cf-9685-1962c9b2d264",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Distributor ID",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "Distributor ID",
                "widgetType": "text-input",
                "mappedApiField": "supplier"
              }
            ]
          },
          {
            "id": "a312fd7b-f01f-46f0-b0e8-3fca2e0d6a2d",
            "name": "User Details",
            "widgets": [
              {
                "id": "ee947ff6-309e-45fd-9f2a-eb9d36430f33",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "LoginID",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "a312fd7b-f01f-46f0-b0e8-3fca2e0d6a2d",
                "columnName": "LoginID",
                "widgetType": "text-input",
                "mappedApiField": "loginid"
              }
            ]
          },
          {
            "id": "f6a0c514-d3c8-45c5-aac0-bcdbd4fcba21",
            "name": "Time Period",
            "widgets": [
              {
                "id": "750f3552-d243-4f5f-aec5-a658f4f275a8",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3"
                  ],
                  "label": "Year",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": true,
                  "defaultOption": "Option 1"
                },
                "sectionId": "f6a0c514-d3c8-45c5-aac0-bcdbd4fcba21",
                "columnName": "Year",
                "widgetType": "dropdown",
                "mappedApiField": "year"
              },
              {
                "id": "e99a2e70-4bcb-49ed-a0fe-d6e995375a2d",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3"
                  ],
                  "label": "Month",
                  "value": "",
                  "editable": true,
                  "hintText": "Select an option",
                  "required": true,
                  "defaultOption": "Option 1"
                },
                "sectionId": "f6a0c514-d3c8-45c5-aac0-bcdbd4fcba21",
                "columnName": "Month",
                "widgetType": "dropdown",
                "mappedApiField": "month"
              }
            ]
          },
          {
            "id": "f5fef600-9b9f-463c-ac07-87ec56701115",
            "name": "Weekly Plan",
            "widgets": [
              {
                "id": "17632bb0-17e0-472e-af84-e9436e107d1c",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "hint": "Select multiple options",
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3",
                    "Option 4",
                    "Option 5"
                  ],
                  "label": "Week1",
                  "value": [],
                  "editable": true,
                  "required": true,
                  "maxOptions": 4
                },
                "sectionId": "f5fef600-9b9f-463c-ac07-87ec56701115",
                "columnName": "Week1",
                "widgetType": "multiselect-dropdown",
                "mappedApiField": "day_and_frequency1"
              },
              {
                "id": "e6206d29-924d-4064-8ae4-b1fba9d15632",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "hint": "Select multiple options",
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3",
                    "Option 4",
                    "Option 5"
                  ],
                  "label": "Week2",
                  "value": [],
                  "editable": true,
                  "required": true,
                  "maxOptions": 4
                },
                "sectionId": "f5fef600-9b9f-463c-ac07-87ec56701115",
                "columnName": "Week2",
                "widgetType": "multiselect-dropdown",
                "mappedApiField": "day_and_frequency2"
              },
              {
                "id": "7386bf18-0e4d-4273-83a9-c9da832c482b",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "hint": "Select multiple options",
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3",
                    "Option 4",
                    "Option 5"
                  ],
                  "label": "Week3",
                  "value": [],
                  "editable": true,
                  "required": true,
                  "maxOptions": 4
                },
                "sectionId": "f5fef600-9b9f-463c-ac07-87ec56701115",
                "columnName": "Week3",
                "widgetType": "multiselect-dropdown",
                "mappedApiField": "day_and_frequency3"
              },
              {
                "id": "905d22a7-4e6d-4aae-ae54-1bd2e66ac4c1",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "hint": "Select multiple options",
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3",
                    "Option 4",
                    "Option 5"
                  ],
                  "label": "Week4",
                  "value": [],
                  "editable": true,
                  "required": true,
                  "maxOptions": 4
                },
                "sectionId": "f5fef600-9b9f-463c-ac07-87ec56701115",
                "columnName": "Week4",
                "widgetType": "multiselect-dropdown",
                "mappedApiField": "day_and_frequency4"
              },
              {
                "id": "336dcff1-535f-4220-bd84-ad7c65afb9d0",
                "config": {
                  "hint": "Select multiple options",
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3",
                    "Option 4",
                    "Option 5"
                  ],
                  "label": "Week5",
                  "value": [],
                  "editable": true,
                  "required": true,
                  "maxOptions": 4
                },
                "sectionId": "f5fef600-9b9f-463c-ac07-87ec56701115",
                "columnName": "Week5",
                "widgetType": "multiselect-dropdown",
                "mappedApiField": "day_and_frequency5"
              },
              {
                "id": "9b013505-46c5-4b4c-a45a-5d325b9c1f35",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "hint": "Select multiple options",
                  "list": [
                    "Option 1",
                    "Option 2",
                    "Option 3",
                    "Option 4",
                    "Option 5"
                  ],
                  "label": "Week6",
                  "value": [],
                  "editable": true,
                  "required": true,
                  "maxOptions": 4
                },
                "sectionId": "f5fef600-9b9f-463c-ac07-87ec56701115",
                "columnName": "Week6",
                "widgetType": "multiselect-dropdown",
                "mappedApiField": "day_and_frequency"
              }
            ]
          },
          {
            "id": "45fd578f-f903-416f-b0d5-ac5d23e8fd84",
            "name": "Beat Info",
            "widgets": [
              {
                "id": "6f7f69d3-6208-4564-9000-6c10eb2673af",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Beat ID",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "45fd578f-f903-416f-b0d5-ac5d23e8fd84",
                "columnName": "Beat ID",
                "widgetType": "text-input",
                "mappedApiField": "beat"
              },
              {
                "id": "bfc653b9-b25c-4986-ae39-0f0ea3c327a3",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "Beat Name",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 206,
                  "regexValidation": ""
                },
                "sectionId": "45fd578f-f903-416f-b0d5-ac5d23e8fd84",
                "columnName": "Beat Name",
                "widgetType": "text-input",
                "mappedApiField": "beatName"
              }
            ]
          }
        ],
        "buttonLabel": "PJP"
      },
      {
        "api": "/productActivity",
        "formId": "1eb2b471-8b70-476f-8b2e-5ca5ccb38847",
        "formName": "Tax Master",
        "sections": [
          {
            "id": "section-1",
            "name": "Tax Identifier",
            "widgets": [
              {
                "id": "2c3e9f27-b28a-42ec-b05f-d7130f0a44a7",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "HSN code (Key)",
                  "value": "",
                  "editable": false,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "HSN code (Key)",
                "widgetType": "text-input",
                "mappedApiField": "HSN code (Key)"
              }
            ]
          },
          {
            "id": "70fe405b-975c-4179-b25b-11e0af9e0bd0",
            "name": "Tax Components",
            "widgets": [
              {
                "id": "e2b4fd80-6491-41dd-9536-01d0883cd1b6",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "CGST (%)",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "70fe405b-975c-4179-b25b-11e0af9e0bd0",
                "columnName": "CGST (%)",
                "widgetType": "text-input",
                "mappedApiField": "CGST (%)"
              },
              {
                "id": "86e96c9e-794c-47bd-a797-fa9da324c54d",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "SGST/UGST (%)",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "70fe405b-975c-4179-b25b-11e0af9e0bd0",
                "columnName": "SGST/UGST (%)",
                "widgetType": "text-input",
                "mappedApiField": "SGST/UGST (%)"
              },
              {
                "id": "ba6b4dc7-dac9-4700-93d3-e98b1fb5ae44",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "IGST (%)",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "70fe405b-975c-4179-b25b-11e0af9e0bd0",
                "columnName": "IGST (%)",
                "widgetType": "text-input",
                "mappedApiField": "IGST (%)"
              },
              {
                "id": "711969d2-c8fd-4571-88b5-893f8a202c1a",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "CESS (%)",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "70fe405b-975c-4179-b25b-11e0af9e0bd0",
                "columnName": "CESS (%)",
                "widgetType": "text-input",
                "mappedApiField": "CESS (%)"
              }
            ]
          }
        ],
        "buttonLabel": "Tax"
      },
      {
        "api": "/products",
        "formId": "681ebd95-1677-4617-b523-a455c501e519",
        "formName": "Prod Auth",
        "sections": [
          {
            "id": "section-1",
            "name": "Prod Auth",
            "widgets": [
              {
                "id": "4a91c51c-1534-4d6f-a9c6-143297ea3eed",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "prodAuthCode",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "prodAuthCode",
                "widgetType": "text-input",
                "mappedApiField": "prodAuthCode"
              },
              {
                "id": "0451e6f5-e873-4311-9318-92f95b6a31bf",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "skuCode",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "columnName": "skuCode",
                "widgetType": "text-input",
                "mappedApiField": "skuCode"
              }
            ]
          },
          {
            "id": "a2b3d44d-9c1c-486d-85f1-a3b24b6e06b4",
            "name": "Other",
            "widgets": []
          }
        ],
        "buttonLabel": "Prod"
      },
      {
        "api": "/userActivity",
        "formId": "0f6d7efe-2b3e-493c-b02b-51b8214bee72",
        "formName": "untitled ",
        "sections": [
          {
            "id": "section-1",
            "name": "Untitled Section 1",
            "widgets": [
              {
                "id": "d17ed762-f63a-4724-94c6-042eca4e7e47",
                "icon": "🔤",
                "name": "Text Input",
                "config": {
                  "label": "TEXT BOX",
                  "value": "",
                  "editable": true,
                  "hintText": "write here",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "email"
                  },
                  "defaultText": "abc@gmail.com",
                  "description": true,
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "sectionId": "section-1",
                "widgetType": "text-input",
                "mappedApiField": "name"
              }
            ]
          }
        ],
        "buttonLabel": "section"
      },
      {
        "api": "",
        "formId": "6e8e24d4-5d65-4707-9596-ece5c3cdf6f4",
        "formName": "Untitled Form",
        "sections": [
          {
            "id": "df2b894d-7003-40e5-8aef-8374c73bbc54",
            "name": "Additional Fields",
            "widgets": [
              {
                "id": "fdbfce67-2067-48e3-824b-b40670345899",
                "config": {
                  "label": "h",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 50,
                  "regexValidation": ""
                },
                "widgetType": "text-input",
                "mappedApiField": ""
              }
            ]
          }
        ],
        "buttonLabel": "Submit"
      },
      {
        "api": "",
        "formId": "33ec31a2-f243-4f40-b78b-1590e99cd7ee",
        "formName": "Untitled Form",
        "sections": [
          {
            "id": "efb5c90c-9f31-4e2b-8fb1-c8301bb4a0d0",
            "name": "Additional Fields",
            "widgets": [
              {
                "id": "fd69da41-1136-4cc1-a37f-38b5e913e12f",
                "config": {
                  "label": "no. label",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 323,
                  "regexValidation": ""
                },
                "columnName": "No.",
                "widgetType": "text-input",
                "mappedApiField": "name"
              },
              {
                "id": "e387d64f-e556-4034-b6f1-7875bf5d427a",
                "config": {
                  "label": "countryCode label",
                  "value": "",
                  "editable": false,
                  "hintText": "",
                  "required": false,
                  "inputType": {
                    "type": "options",
                    "values": [
                      "text",
                      "email",
                      "password",
                      "number",
                      "tel",
                      "url"
                    ],
                    "selected": "text"
                  },
                  "defaultText": "",
                  "description": "",
                  "maxCharacters": 32323,
                  "regexValidation": ""
                },
                "columnName": "Region",
                "widgetType": "text-input",
                "mappedApiField": "countryCode"
              }
            ]
          }
        ],
        "buttonLabel": "Submit"
      }
    ]
  }
]

export const allmenuOption = [
  { id: 'import', label: 'Import' },
  { id: 'logsAndReport', label: 'Logs and Reports' },
  { id: 'viewsAndEdit', label: 'View and Edit' },
  { id: 'masterDownload', label: 'Master Download' },
  { id: 'dataSupportDownload', label: 'Data Validation Support' },
];
export type TransformerType = {
  entityName: string;
  transformerId: string;
  operationType?: string;
  preprocessValidationExcludeGroup?:string
};

export interface Card {
  id: string;
  name: string;
  templateUrl: string;
  actions?:string[];
  activeStatusKey?: string;
  formId?: string;
  formConfiguration?: any;
  tableConfiguration: {
      columns: {
          mandatory: boolean; id: string; label: string; columnName: string 
}[];
  };
}

export interface ExcelColumns {
  [key: string]: string[]; // Card ID => Column Names
}

export type MdmColumnSetUpProps = {
setExcelMasterColumns: (cols: ExcelColumns) => void;
};